/* sm-barm-vel.js - Nafnaskilti a barm: shared badge engine (window.SMBarm).
   One engine for three jobs: templates are authored with it, the owner boards
   are rendered with it, and the product page (sm-barmmerki.js) runs it as the
   live preview. It also writes the production spec (_framleidsla) for an order.
   Plain ES5 IIFE, no dependencies, no DOM except canvas measuring.
   BUILT FILE: edit src/sm-barm-vel.src.js and run `node build.mjs`. The build
   injects the icon map from takn/*.svg and escapes every non-ASCII character
   (the Shopify CDN minifier mangles raw UTF-8 in assets).
   1.2.0 (2026-09-27): usual badge sizes 70 x 20, 76 x 25 and 76 x 38 mm
   (breidd x haed), one 3 mm corner radius for every size and template, all
   customer facing words in one dictionary (SMBarm.ord), framleidsla().
   1.3.0 (2026-09-27): multi field templates (T.reitir) for verkamerki
   (artwork labels): product and material registries (VORUR, EFNI incl.
   the safety colours and steel/brass processes), rich rows (several
   fonts on one line), balanced and paragraph wrapping, fixed cells and a
   flow grid, per size photo faces, tone in tone metal engraving, and
   smfram() for the production core (SMFram). Badge templates (no
   T.reitir) take exactly the 1.2.0 code path, byte identical output.
   1.3.1 (2026-09-27): artwork labels "Skilti fyrir listaverk": font choice
   (T.letur_val, D.letur) with a size table per font and look, a material
   floor on every text size (cap height never under E.lagmark_cap), only
   the fields shown on the sign reach the summary, cart, aria text and
   production header, a dashed placement box for logos the browser cannot
   draw (PDF, AI, EPS) or that come as a description, one font size for
   every cell of a flow grid, a 0.1 mm tolerance on the safe area, square
   corners on every material and frames at two insets (door sign frame).
   1.4.0 (2026-09-28): bag tags "T\u00f6skumerki \u00far akr\u00fdl me\u00f0 nafni" (vara
   toskumerki, 75 x 75 mm): product shape (corner radius and the slot for
   the steel wire loop, a real hole in the preview, SKERA-INNRA in the
   production file), an optional steel wire loop in the preview
   (O.lykkja), a product text floor (cap height 3 mm), solid matt acrylic
   (einlitt-*, engraved tone in tone like the metals), filled graphics in
   templates (grafik: icons, rings, lines, as paths drawn and engraved the
   same way; lina: true = one score line), fixed text parts in rows ({fast: 'FR\u00c1'}) and smfram options
   for two sided tags (O.hopur, O.dx, O.dy, O.utlina). Badges and artwork
   labels take exactly the 1.3.1 code paths, byte identical output. */
(function (win) {
  "use strict";
  var doc = win.document;
  var VERSION = "1.4.0";
  /* Frames (owner 2026-09-29): every frame and every template divider is
     ONE score line (LINA) on the centre line of the old engraved band,
     never a filled band. The preview draws those lines this wide (mm);
     tune it after measuring the real scored line. */
  var RAMMI_FORSKODUN_MM = 0.3;

  /* ------------------------------------------------------------------
     1. PRODUCT FACTS
     ------------------------------------------------------------------ */
  /* Sizes, key "<breidd>x<haed>" in mm (owner 2026-09-27: the usual badge
     sizes, much lower than the first 50 mm wide drafts). 76 x 25 mm is the
     common standard and the default. Shopify labels ("7,6 x 2,5 cm") are read
     by staerdLykill(). */
  var STAERDIR = {
    "70x20": { b: 70, h: 20 },
    "76x25": { b: 76, h: 25 },
    "76x38": { b: 76, h: 38 }
  };
  var STAERD_SJALFGEFIN = "76x25";
  /* One corner radius for every size and template (industry standard about
     1/8 inch). Templates cannot change it; a frame follows it inwards. */
  var HORN = 3;

  /* Two-tone acrylic. flotur = average face colour of the real door-sign
     photo crop (efni/*.webp), kjarni = engraved core colour (door-sign house
     style). The edge copies what the door-sign photos show along the cut:
     glampi = light rim along the top edge (opacity), botn = light or dark band
     inside the bottom edge { h mm, lit, op }, lina = hairline on the outline
     { lit, op }. Measured on the atlas photos and the live door-sign preview. */
  var LITIR = {
    gull:   { flotur: "#e2b986", kjarni: "#1a1815", ljos: true,
              glampi: 0.5, botn: { h: 0.45, lit: "#fff3e4", op: 0.4 }, lina: { lit: "#8f6d47", op: 0.45 } },
    silfur: { flotur: "#b4beba", kjarni: "#1a1815", ljos: true,
              glampi: 0.35, botn: { h: 0.35, lit: "#000000", op: 0.1 }, lina: { lit: "#5c6461", op: 0.6 } },
    svart:  { flotur: "#080b0a", kjarni: "#ffffff", ljos: false,
              glampi: 0.22, botn: { h: 1.3, lit: "#a9bcc4", op: 0.12 }, lina: { lit: "#000000", op: 0.7 } },
    hvitt:  { flotur: "#fcfbfc", kjarni: "#1a1815", ljos: true,
              glampi: 0.0, botn: { h: 0.35, lit: "#000000", op: 0.05 }, lina: { lit: "#8e8e8e", op: 0.75 } }
  };

  /* Tabler outline icons (MIT), 24x24, stroke 2. Injected by build.mjs. */
  var TAKN = {"check":["M5 12l5 5l10 -10"],"device-laptop":["M3 19l18 0","M5 6m0 1a1 1 0 0 1 1 -1h12a1 1 0 0 1 1 1v8a1 1 0 0 1 -1 1h-12a1 1 0 0 1 -1 -1z"],"heart":["M19.5 12.572l-7.5 7.428l-7.5 -7.428a5 5 0 1 1 7.5 -6.566a5 5 0 1 1 7.5 6.572"],"info-circle":["M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0","M12 9h.01","M11 12h1v4h1"],"mood-smile":["M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0","M9 10l.01 0","M15 10l.01 0","M9.5 15a3.5 3.5 0 0 0 5 0"],"paw":["M14.7 13.5c-1.1 -2 -1.441 -2.5 -2.7 -2.5c-1.259 0 -1.736 .755 -2.836 2.747c-.942 1.703 -2.846 1.845 -3.321 3.291c-.097 .265 -.145 .677 -.143 .962c0 1.176 .787 2 1.8 2c1.259 0 3 -1 4.5 -1s3.241 1 4.5 1c1.013 0 1.8 -.823 1.8 -2c0 -.285 -.049 -.697 -.146 -.962c-.475 -1.451 -2.512 -1.835 -3.454 -3.538z","M20.188 8.082a1.039 1.039 0 0 0 -.406 -.082h-.015c-.735 .012 -1.56 .75 -1.993 1.866c-.519 1.335 -.28 2.7 .538 3.052c.129 .055 .267 .082 .406 .082c.739 0 1.575 -.742 2.011 -1.866c.516 -1.335 .273 -2.7 -.54 -3.052z","M9.474 9c.055 0 .109 0 .163 -.011c.944 -.128 1.533 -1.346 1.32 -2.722c-.203 -1.297 -1.047 -2.267 -1.932 -2.267c-.055 0 -.109 0 -.163 .011c-.944 .128 -1.533 1.346 -1.32 2.722c.204 1.293 1.048 2.267 1.933 2.267z","M16.456 6.733c.214 -1.376 -.375 -2.594 -1.32 -2.722a1.164 1.164 0 0 0 -.162 -.011c-.885 0 -1.728 .97 -1.93 2.267c-.214 1.376 .375 2.594 1.32 2.722c.054 .007 .108 .011 .162 .011c.885 0 1.73 -.974 1.93 -2.267z","M5.69 12.918c.816 -.352 1.054 -1.719 .536 -3.052c-.436 -1.124 -1.271 -1.866 -2.009 -1.866c-.14 0 -.277 .027 -.407 .082c-.816 .352 -1.054 1.719 -.536 3.052c.436 1.124 1.271 1.866 2.009 1.866c.14 0 .277 -.027 .407 -.082z"],"phone":["M5 4h4l2 5l-2.5 1.5a11 11 0 0 0 5 5l1.5 -2.5l5 2v4a2 2 0 0 1 -2 2a16 16 0 0 1 -15 -15a2 2 0 0 1 2 -2"],"shopping-cart":["M6 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0","M17 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0","M17 17h-11v-14h-2","M6 5l14 1l-1 7h-13"],"star":["M12 17.75l-6.172 3.245l1.179 -6.873l-5 -4.867l6.9 -1l3.086 -6.253l3.086 6.253l6.9 1l-5 4.867l1.179 6.873z"],"tools-kitchen-3":["M7 4v17m-3 -17v3a3 3 0 1 0 6 0v-3","M14 8a3 4 0 1 0 6 0a3 4 0 1 0 -6 0","M17 12v9"]};
  /* Every word a customer can see lives in this one dictionary. A page for
     another language replaces entries (SMBarm.ord.vandamal.vantar_nafn = ...)
     before drawing; codes (keys) never change. Icon labels come from the
     Easify options; "Hak" and "Ekkert" replace "Check-Mark" and "Enga mynd". */
  var ORD = {
    aria: "Nafnaskilti \u00e1 barm",
    litir: { gull: "Gull", silfur: "Silfur", svart: "Svart", hvitt: "Hv\u00edtt" },
    staerdir: { "70x20": "7 \u00d7 2 cm", "76x25": "7,6 \u00d7 2,5 cm", "76x38": "7,6 \u00d7 3,8 cm" },
    takn: {
      "heart": "Hjarta", "device-laptop": "T\u00f6lva", "info-circle": "Uppl\u00fdsingamerki",
      "mood-smile": "Broskall", "paw": "D\u00fdraf\u00f3tspor", "phone": "S\u00edmi",
      "shopping-cart": "Innkaupakarfa", "star": "Stjarna", "tools-kitchen-3": "Hn\u00edfapar",
      "check": "Hak"
    },
    taknEngin: "Ekkert",
    vandamal: {
      vantar_nafn: "Vantar nafn",
      nafn_of_langt: "Nafni\u00f0 er of langt fyrir \u00feessa st\u00e6r\u00f0",
      titill_of_langur: "Textinn fyrir ne\u00f0an nafni\u00f0 er of langur fyrir \u00feessa st\u00e6r\u00f0",
      of_hatt: "Textinn kemst ekki fyrir \u00e1 merkinu",
      logo_ekki_i_bodi: "\u00deetta sni\u00f0 b\u00fd\u00f0ur ekki upp \u00e1 logo",
      logo_passar_ekki: "Ekkert pl\u00e1ss fyrir logo \u00ed \u00feessu sni\u00f0i",
      takn_passar_ekki: "Ekki er pl\u00e1ss fyrir b\u00e6\u00f0i logo og t\u00e1kn \u00ed \u00feessu sni\u00f0i",
      takn_othekkt: "\u00d3\u00feekkt t\u00e1kn",
      staerd_vantar: "Sni\u00f0i\u00f0 er ekki til \u00ed \u00feessari st\u00e6r\u00f0",
      utan_oruggs: "Texti n\u00e6r of n\u00e1l\u00e6gt br\u00faninni",
      logo_litid: "Logoi\u00f0 ver\u00f0ur mj\u00f6g l\u00edti\u00f0",
      nafn_smatt: "Nafni\u00f0 ver\u00f0ur mj\u00f6g sm\u00e1tt \u00ed \u00feessari st\u00e6r\u00f0"
    }
  };
  var TAKN_HEITI = ORD.takn;
  /* Old keys still accepted. tools-kitchen-2 (fork + knife) read as "Y4" at
     3 to 4 mm, so Hn\u00edfapar is now fork + spoon (tools-kitchen-3). */
  var TAKN_SAMHEITI = { "tools-kitchen-2": "tools-kitchen-3" };

  /* "LOGO" drawn with strokes (font independent), box 94 x 24, stroke 4 */
  var LOGO_STAFIR = "M3 2V22H14M19 12a10 10 0 1 0 20 0a10 10 0 1 0 -20 0M62.07 4.93A10 10 0 1 0 65 12H56M71 12a10 10 0 1 0 20 0a10 10 0 1 0 -20 0";

  /* Codes the customer must fix before ordering. The others are warnings. */
  var STOPP = { vantar_nafn: 1, nafn_of_langt: 1, titill_of_langur: 1, of_hatt: 1, staerd_vantar: 1 };

  var SYNISTAFIR = "Aa\u00c1\u00e1\u00d0\u00f0\u00c9\u00e9\u00cd\u00ed\u00d3\u00f3\u00da\u00fa\u00dd\u00fd\u00de\u00fe\u00c6\u00e6\u00d6\u00f60123456789 -.&";

  /* ------------------------------------------------------------------
     2. SMALL HELPERS
     ------------------------------------------------------------------ */
  function r3(n) { return Math.round(n * 1000) / 1000; }
  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]; }); }
  function erHlutur(o) { return o && typeof o === "object" && !(o instanceof Array); }
  function afrit(o) { return o == null ? o : JSON.parse(JSON.stringify(o)); }
  /* Deep merge: objects merge, arrays and scalars replace, null deletes */
  function blanda(a, b) {
    var ut = afrit(a) || {}, k;
    for (k in b) if (Object.prototype.hasOwnProperty.call(b, k)) {
      if (b[k] === null) delete ut[k];
      else if (erHlutur(b[k]) && erHlutur(ut[k])) ut[k] = blanda(ut[k], b[k]);
      else ut[k] = afrit(b[k]);
    }
    return ut;
  }
  function fjoldiStafa(t) { return String(t).replace(/[\uD800-\uDBFF][\uDC00-\uDFFF]/g, "_").length; }
  function umbreyta(L, t) {
    t = String(t == null ? "" : t).replace(/[\u2013\u2014]/g, "-").replace(/\s+/g, " ").replace(/^ | $/g, "");
    if (L && L.caps) t = t.toLocaleUpperCase ? t.toLocaleUpperCase("is-IS") : t.toUpperCase();
    return t;
  }
  /* 'gull' | 'silfur' | 'svart' | 'hvitt', also the Shopify labels 'Gull', 'Hv\u00edtt'; unknown -> gull */
  function litLykill(x) {
    var k = String(x || "").toLowerCase().replace(/\u00ed/g, "i").replace(/^\s+|\s+$/g, "");
    return LITIR[k] ? k : "gull";
  }
  function v(kodi) { return { kodi: kodi, texti: (ORD.vandamal && ORD.vandamal[kodi]) || kodi, stopp: !!STOPP[kodi] }; }
  /* '76x25', the Shopify value '7,6 x 2,5 cm', '7.6x2.5cm' or '76 x 25 mm' -> '76x25'.
     Unknown -> the default size (76 x 25). */
  function staerdLykill(x) {
    var s = String(x == null ? "" : x).toLowerCase().replace(/\s+/g, "").replace(/\u00d7/g, "x");
    if (STAERDIR[s]) return s;
    var m = /^(\d+(?:[.,]\d+)?)x(\d+(?:[.,]\d+)?)(mm|cm)?$/.exec(s);
    if (!m) return STAERD_SJALFGEFIN;
    var a = parseFloat(m[1].replace(",", ".")), b = parseFloat(m[2].replace(",", "."));
    var k = m[3] === "mm" || (!m[3] && a > 20) ? 1 : 10;
    var lyk = Math.round(a * k) + "x" + Math.round(b * k);
    return STAERDIR[lyk] ? lyk : STAERD_SJALFGEFIN;
  }

  /* ------------------------------------------------------------------
     3. FONTS AND MEASURING
     ------------------------------------------------------------------ */
  function vara(L) { return L.vara || (/sans|mono|grotesk|montserrat|jost|manrope|lato|roboto|arimo|cabin|nunito|oswald|quicksand|raleway|inter|open sans/i.test(L.family) ? "sans-serif" : "serif"); }
  function leturStrengur(L, px) {
    return (L.style === "italic" ? "italic " : "") + (L.weight || 400) + " " + px + "px \"" + (({"Dancing Script":"SM Skrift","IBM Plex Mono":"SM Mono"})[L.family] || L.family) + "\", " + vara(L);
  }
  var CNV = null, MAEL = {};
  function samhengi() {
    if (!CNV) { CNV = doc.createElement("canvas"); CNV.width = CNV.height = 8; }
    return CNV.getContext("2d");
  }
  function hladid(L) {
    try { return !doc.fonts || doc.fonts.check(leturStrengur(L, 20), "Aa"); } catch (e) { return true; }
  }
  /* Vertical metrics per font as fractions of the font size */
  function maelingar(L) {
    var k = leturStrengur(L, 100);
    if (MAEL[k]) return MAEL[k];
    var c = samhengi(); c.font = k;
    var h = c.measureText("H"), d = c.measureText("gjpqy"), a = c.measureText("\u00c1\u00d3\u00cd\u00c9\u00da");
    var r = {
      cap: (h.actualBoundingBoxAscent || 70) / 100,
      desc: (d.actualBoundingBoxDescent || 22) / 100,
      hrodd: (a.actualBoundingBoxAscent || 90) / 100
    };
    if (hladid(L)) MAEL[k] = r;
    return r;
  }
  /* Width in mm of text at font size mm, tracking only between glyphs.
     With tracking, Chrome drops some ligatures and kerning in SVG text, so
     the canvas measures WITH letterSpacing where the browser has it (it then
     matches the SVG exactly) and subtracts the trailing space. */
  function breidd(L, t, mm) {
    if (!t) return 0;
    var c = samhengi(), ls = L.tracking_em || 0;
    c.font = leturStrengur(L, 100);
    if (ls && "letterSpacing" in c) {
      c.letterSpacing = (ls * 100) + "px";
      var w = c.measureText(t).width;
      c.letterSpacing = "0px";
      return (w - ls * 100) / 100 * mm;
    }
    return c.measureText(t).width / 100 * mm + ls * mm * Math.max(0, fjoldiStafa(t) - 1);
  }
  /* Real ink box of a line (accents included), mm, relative to the start point and baseline */
  function blek(L, t, mm) {
    var c = samhengi(); c.font = leturStrengur(L, 100);
    var m = c.measureText(t), k = mm / 100;
    return { upp: (m.actualBoundingBoxAscent || 0) * k, nidur: (m.actualBoundingBoxDescent || 0) * k,
             vinstri: -(m.actualBoundingBoxLeft || 0) * k, haegri: breidd(L, t, mm) };
  }

  /* Best split into two lines: minimises the longer line */
  function skipta(L, t, auka) {
    var ord = t.split(" "); if (ord.length < 2) return null;
    var best = null, i;
    for (i = 1; i < ord.length; i++) {
      var a = ord.slice(0, i).join(" "), b = ord.slice(i).join(" ");
      var m = Math.max(breidd(L, a, 1) + (auka || 0), breidd(L, b, 1));
      if (!best || m < best.m) best = { l: [a, b], m: m };
    }
    return best;
  }

  /* Fit one text into width w (mm). regla: 'minnka' | 'tvaer_linur'.
     auka = extra width in em on the first line (an inline icon).
     Returns { linur, s (font size mm), ok, sx (horizontal squeeze if too long) } */
  function fitta(L, t, w, regla, auka) {
    auka = auka || 0;
    var min = L.min_mm || 1, max = L.max_mm || 10;
    var one = breidd(L, t, 1) + auka;
    var s1 = Math.min(max, w / one);
    var res = { linur: [t], s: s1, ok: true, sx: 1 };
    var sk = regla === "tvaer_linur" ? skipta(L, t, auka) : null;
    /* never below min_mm: a split point under the minimum would skip the
       two line option for names that only fit on two lines */
    var undir = Math.max(L.skipta_undir_mm || min, min);
    if (sk && s1 < undir - 1e-6) {
      var s2 = Math.min(max, w / sk.m);
      if (s2 > s1) res = { linur: sk.l, s: s2, ok: true, sx: 1 };
    }
    if (res.s < min - 1e-6) {
      var mw = res.linur.length > 1 ? sk.m : one;
      res = { linur: res.linur, s: min, ok: false, sx: w / (mw * min) };
    }
    return res;
  }
  function textaHaed(L, f) {
    var M = maelingar(L), lb = L.linubil || 1.2;
    return M.cap * f.s + (f.linur.length - 1) * lb * f.s;
  }

  /* ------------------------------------------------------------------
     4. LAYOUT
     ------------------------------------------------------------------ */
  function stafliHefur(lay, hlutur) { return !!(lay && lay.stafli && (lay.stafli.rod || []).indexOf(hlutur) >= 0); }
  function holfHefur(lay, hlutur) { return !!(lay && lay.holf && lay.holf[hlutur]); }

  function beitaEf(lay, skil) {
    var ut = afrit(lay), ef = ut.ef || {}, lyklar = [], k;
    delete ut.ef;
    for (k in ef) if (Object.prototype.hasOwnProperty.call(ef, k)) lyklar.push(k);
    lyklar.sort(function (a, b) { return a.split("+").length - b.split("+").length; });
    lyklar.forEach(function (k) {
      var allt = k.split("+").every(function (s) { return !!skil[s.replace(/^\s+|\s+$/g, "")]; });
      if (allt) ut = blanda(ut, ef[k]);
    });
    return ut;
  }

  function taknTil(key, O) { return !!(key && ((O && O.takn && O.takn[key]) || TAKN[key])); }

  function fitLogo(box, r) {
    var w = box.w, h = box.h;
    if (w / h > r) w = h * r; else h = w / r;
    return { w: w, h: h };
  }
  function jafna(jofnun, x, w, breiddHlutar) {
    if (jofnun === "vinstri") return x;
    if (jofnun === "haegri") return x + w - breiddHlutar;
    return x + (w - breiddHlutar) / 2;
  }

  /* Compute everything: sizes, positions, problems. teikna() draws this. */
  function uppsetning(T, D, O) {
    if (T && T.reitir) return uppsetningV(T, D, O);
    D = D || {}; O = O || {};
    T = T || {};
    var sk = staerdLykill(D.staerd);
    var S = STAERDIR[sk], B = S.b, H = S.h;
    var vand = [];
    var grunnur = (T.staerdir || {})[sk];
    if (!grunnur) { vand.push(v("staerd_vantar")); grunnur = {}; }
    var reglur = T.reglur || {}, letur = T.letur || {};
    var nafn = umbreyta(null, D.nafn), titill = umbreyta(null, D.titill);
    if (!nafn) vand.push(v("vantar_nafn"));

    var logo = D.logo || null;
    if (logo && logo !== "stadgengill" && !(logo.mynd && logo.r)) logo = null;
    if (logo && reglur.logo === false) { vand.push(v("logo_ekki_i_bodi")); logo = null; }
    var takn = D.takn || null;
    if (takn && TAKN_SAMHEITI[takn] && !taknTil(takn, O)) takn = TAKN_SAMHEITI[takn];
    if (takn && !taknTil(takn, O)) { vand.push(v("takn_othekkt")); takn = null; }

    var hefurTaknHolf = holfHefur(grunnur, "takn") || stafliHefur(grunnur, "takn");
    var hefurLogoHolf = holfHefur(grunnur, "logo") || stafliHefur(grunnur, "logo");
    if (logo && !hefurLogoHolf) { vand.push(v("logo_passar_ekki")); logo = null; }
    var taknILogo = !!(takn && !hefurTaknHolf && hefurLogoHolf && !logo);
    if (takn && !hefurTaknHolf && !taknILogo) { vand.push(v("takn_passar_ekki")); takn = null; }

    var rammiA = !!(grunnur.rammi && (reglur.rammi === "val" ? D.rammi === true : D.rammi !== false));
    var skil = {
      anLogos: !logo && !taknILogo, medLogo: !!logo || taknILogo,
      anTitils: !titill, medTitli: !!titill,
      anTakns: !takn, medTakni: !!takn,
      /* breittLogo: an uploaded logo at least 2.4 times wider than tall (a
         wordmark). Lets a template move a wide logo to where it can be big. */
      breittLogo: !!(logo && logo !== "stadgengill" && logo.r >= 2.4),
      medRamma: rammiA, anRamma: !rammiA
    };
    var L = beitaEf(grunnur, skil);
    var holf = L.holf || {};
    /* Fonts: template letur, optionally overridden per layout (layout.letur) */
    var LN = blanda(letur.nafn || { family: "Montserrat", weight: 500, min_mm: 2, max_mm: 5 }, (L.letur && L.letur.nafn) || {});
    var LT = blanda(letur.titill || LN, (L.letur && L.letur.titill) || {});
    nafn = umbreyta(LN, nafn); titill = umbreyta(LT, titill);

    var U = {
      staerd: sk, B: B, H: H, horn: HORN,
      rammi: rammiA && L.rammi ? L.rammi : null,
      linur: L.linur || [], flatar: L.flatar || [],
      textar: [], logo: null, takn: null, vand: vand, skil: skil,
      info: { nafnStaerdMm: 0, nafnHaedMm: 0, nafnLinur: 0, nafnSx: 1, titillStaerdMm: 0, titillHaedMm: 0, titillLinur: 0, logoHaedMm: 0, logoBreiddMm: 0, hopurFaersla: 0 }
    };

    /* What goes where */
    var hlutir = {};
    if (nafn) hlutir.nafn = { teg: "texti", L: LN, t: nafn, regla: reglur.langtNafn || "minnka" };
    if (titill) hlutir.titill = { teg: "texti", L: LT, t: titill, regla: reglur.langurTitill || "minnka" };
    if (logo) hlutir.logo = { teg: "logo", logo: logo };
    if (takn && taknILogo) hlutir.logo = { teg: "takn", takn: takn, iLogo: true };
    else if (takn) hlutir.takn = { teg: "takn", takn: takn };

    /* Inline icon next to the name: holf.takn = { vid: 'nafn', hlid, h_em, bil_em } */
    var innTakn = holf.takn && holf.takn.vid === "nafn" && hlutir.takn && hlutir.nafn ? holf.takn : null;
    var aukaEm = innTakn ? (innTakn.h_em || 0.9) + (innTakn.bil_em || 0.4) : 0;

    function textaUt(hl, f, x0, w, jofnun, topp) {
      var M = maelingar(hl.L), lb = hl.L.linubil || 1.2, linur = [], i;
      for (i = 0; i < f.linur.length; i++) {
        var t = f.linur[i], wl = breidd(hl.L, t, f.s) * f.sx;
        var auka = (i === 0 && hl === hlutir.nafn && innTakn) ? aukaEm * f.s : 0;
        var x = jafna(jofnun, x0, w, wl + auka);
        var y = topp + M.cap * f.s + i * lb * f.s;
        var ln = { t: t, x: x + (innTakn && i === 0 && hl === hlutir.nafn && (innTakn.hlid || "vinstri") === "vinstri" ? auka : 0), y: y, w: wl };
        if (auka) {
          var ih = (innTakn.h_em || 0.9) * f.s, ix = innTakn.hlid === "haegri" ? x + wl + (innTakn.bil_em || 0.4) * f.s : x;
          U.takn = { key: hlutir.takn.takn, x: ix, y: y - M.cap * f.s / 2 - ih / 2, s: ih, strik: innTakn.strik, utskorid: innTakn.utskorid };
        }
        linur.push(ln);
      }
      return { hlutur: hl === hlutir.nafn ? "nafn" : "titill", L: hl.L, s: f.s, sx: f.sx, linur: linur, utskorid: false };
    }
    function skraInfo(nafnF, titF) {
      if (nafnF) {
        U.info.nafnStaerdMm = r3(nafnF.s); U.info.nafnHaedMm = r3(maelingar(LN).cap * nafnF.s);
        U.info.nafnLinur = nafnF.linur.length; U.info.nafnSx = r3(nafnF.sx);
        if (!nafnF.ok) vand.push(v("nafn_of_langt"));
        /* Warning, not a stop: fits, but the cap height is under
           reglur.smatt_undir_mm (default 2.0 mm), hard to read at arm's length. */
        else if (U.info.nafnHaedMm < (reglur.smatt_undir_mm || 2.0)) vand.push(v("nafn_smatt"));
      }
      if (titF) {
        U.info.titillStaerdMm = r3(titF.s); U.info.titillHaedMm = r3(maelingar(LT).cap * titF.s);
        U.info.titillLinur = titF.linur.length;
        if (!titF.ok) vand.push(v("titill_of_langur"));
      }
    }
    function setjaLogo(hl, x, y, w, h, spec) {
      if (hl.teg === "logo") {
        if (hl.logo === "stadgengill") U.logo = { stadgengill: true, x: x, y: y, w: w, h: h, utskorid: spec && spec.utskorid };
        else U.logo = { mynd: hl.logo.mynd, x: x, y: y, w: w, h: h, utskorid: spec && spec.utskorid };
        U.info.logoHaedMm = r3(h); U.info.logoBreiddMm = r3(w);
        if (h < 3 && w < 12) vand.push(v("logo_litid"));
      } else {
        var s = Math.min(w, h);
        U.takn = { key: hl.takn, x: x + (w - s) / 2, y: y + (h - s) / 2, s: s, strik: spec && spec.strik, utskorid: spec && spec.utskorid };
      }
    }

    /* Title never outgrows the name: letur.titill.max_hlutfall caps the
       title size at that fraction of the name's width-fitted size. */
    if (hlutir.nafn && hlutir.titill && LT.max_hlutfall) {
      var nb = stafliHefur(L, "nafn") ? L.stafli.w : (holf.nafn ? holf.nafn.w : 0);
      if (nb) {
        var ns = fitta(LN, nafn, nb, hlutir.nafn.regla, aukaEm).s;
        hlutir.titill.L = blanda(LT, { max_mm: Math.max(LT.min_mm || 1, Math.min(LT.max_mm || 10, LT.max_hlutfall * ns)) });
      }
    }

    /* 4a. Fixed boxes (holf) for items not in the stack */
    var nafnF = null, titF = null;
    ["logo", "takn", "nafn", "titill"].forEach(function (k) {
      var hl = hlutir[k], box = holf[k];
      if (!hl || !box || box.vid || stafliHefur(L, k)) return;
      var jof = box.jofnun || "midja";
      if (hl.teg === "texti") {
        var f = fitta(hl.L, hl.t, box.w, hl.regla, k === "nafn" ? aukaEm : 0);
        var hh = textaHaed(hl.L, f);
        if (hh > box.h + 1e-6) {
          f.s = Math.max(hl.L.min_mm || 1, f.s * box.h / hh);
          if (textaHaed(hl.L, f) > box.h + 0.05) vand.push(v("of_hatt"));
          hh = textaHaed(hl.L, f);
        }
        var topp = box.grunnlina != null ? box.grunnlina - maelingar(hl.L).cap * f.s : box.y + (box.h - hh) / 2;
        var tx = textaUt(hl, f, box.x, box.w, jof, topp);
        tx.utskorid = !!box.utskorid;
        U.textar.push(tx);
        if (k === "nafn") nafnF = f; else titF = f;
      } else if (hl.teg === "logo" && !hl.iLogo) {
        var fl = fitLogo(box, hl.logo === "stadgengill" ? 2.2 : hl.logo.r);
        setjaLogo(hl, jafna(jof, box.x, box.w, fl.w), box.y + (box.h - fl.h) / 2, fl.w, fl.h, box);
      } else {
        var kv = hl.iLogo ? (L.taknKvardi || 0.72) : 1, ts = Math.min(box.w, box.h) * kv;
        setjaLogo(hl, jafna(jof, box.x, box.w, ts), box.y + (box.h - ts) / 2, ts, ts, box);
      }
    });

    /* 4b. The stack: rows placed top to bottom, shrunk together if too tall */
    var st = L.stafli;
    if (st) {
      var rows = [];
      (st.rod || []).forEach(function (k) {
        if (k === "strik") {
          /* A short engraved rule as a stack row: drawn only when a row
             above it exists, so it never dangles on its own. */
          var sk2 = st.strik || {};
          if (rows.length) rows.push({ k: k, strik: true, lw: sk2.w || 12, lh: sk2.strik || 0.3, sk: sk2 });
          return;
        }
        var hl = hlutir[k];
        if (!hl) return;
        if (hl.teg === "texti") {
          var f = fitta(hl.L, hl.t, st.w, hl.regla, k === "nafn" ? aukaEm : 0);
          rows.push({ k: k, hl: hl, f: f, s0: f.s });
        } else if (hl.teg === "logo" && !hl.iLogo) {
          var lb = { w: (st.logo && st.logo.w) || st.w, h: (st.logo && st.logo.h) || 6 };
          var fl = fitLogo(lb, hl.logo === "stadgengill" ? 2.2 : hl.logo.r);
          rows.push({ k: k, hl: hl, lw: fl.w, lh: fl.h, min: (st.logo && st.logo.min_h) || fl.h * 0.6 });
        } else {
          var th = hl.iLogo ? ((st.takn && st.takn.h) || ((st.logo && st.logo.h) || 6) * 0.72) : ((st.takn && st.takn.h) || 4);
          rows.push({ k: k, hl: hl, lw: th, lh: th, min: th * 0.7 });
        }
      });
      var bil = st.bil || {};
      function gap(i) { var k = rows[i - 1].k; return bil[k] != null ? bil[k] : (st.bil_sjalfgefid != null ? st.bil_sjalfgefid : 1.5); }
      function haedVid(f) {
        var t = 0, i;
        for (i = 0; i < rows.length; i++) {
          var r = rows[i];
          if (r.strik) { r.h = r.lh; r.hs = 1; }
          else if (r.f) {
            var s = r.s0 >= (r.hl.L.min_mm || 1) ? Math.max(r.hl.L.min_mm || 1, r.s0 * f) : r.s0;
            r.hs = s; r.h = textaHaed(r.hl.L, { s: s, linur: r.f.linur });
          } else { r.h = Math.max(r.min, r.lh * f); r.hs = r.h / r.lh; }
          t += r.h + (i ? gap(i) : 0);
        }
        return t;
      }
      var fk = 1, heild = haedVid(1);
      if (heild > st.h + 1e-6) {
        var lo = 0, hi = 1, j;
        for (j = 0; j < 24; j++) { var mid = (lo + hi) / 2; if (haedVid(mid) > st.h) hi = mid; else lo = mid; }
        fk = lo; heild = haedVid(fk);
        if (heild > st.h + 0.05) vand.push(v("of_hatt"));
      }
      var lod = st.lodrett || "midja";
      var y = lod === "efst" ? st.y : lod === "nedst" ? st.y + st.h - heild : st.y + (st.h - heild) / 2;
      y += st.hlidrun || 0;
      var jof = st.jofnun || "midja";
      rows.forEach(function (r, i) {
        if (i) y += gap(i);
        if (r.strik) {
          var sx0 = jafna(jof, st.x, st.w, r.lw);
          U.linur = U.linur.concat([{ x1: sx0, y1: y + r.lh / 2, x2: sx0 + r.lw, y2: y + r.lh / 2, strik: r.lh, endi: r.sk.endi || "butt" }]);
        } else if (r.f) {
          r.f.s = r.hs;
          var tx = textaUt(r.hl, r.f, st.x, st.w, jof, y);
          U.textar.push(tx);
          if (r.k === "nafn") nafnF = r.f; else titF = r.f;
        } else {
          var w = r.lw * r.hs, h = r.h;
          setjaLogo(r.hl, jafna(jof, st.x, st.w, w), y, w, h, st.logo);
        }
        y += r.h;
      });
    }
    skraInfo(nafnF, titF);

    /* 4c. Group centring: hopur = { jofnun: 'midja', x, w }. Everything that
       was placed (text, logo, icon, divider lines) moves sideways as one unit
       so its ink is centred in x..x+w (default: the whole badge). A left
       anchored logo | divider | text layout then stays balanced whether the
       name is short or long. Bands and frames do not move. */
    if (L.hopur && (L.hopur.jofnun || "midja") === "midja") {
      var gx0 = Infinity, gx1 = -Infinity;
      var ut1 = function (a, b) { if (a < gx0) gx0 = a; if (b > gx1) gx1 = b; };
      U.textar.forEach(function (tx) { tx.linur.forEach(function (ln) { ut1(ln.x, ln.x + ln.w); }); });
      if (U.logo) ut1(U.logo.x, U.logo.x + U.logo.w);
      if (U.takn) ut1(U.takn.x, U.takn.x + U.takn.s);
      U.linur.forEach(function (ln) { ut1(Math.min(ln.x1, ln.x2), Math.max(ln.x1, ln.x2)); });
      U.flatar.forEach(function (fl) { if (fl.hopur) ut1(fl.x, fl.x + fl.w); });
      if (gx1 > gx0) {
        var ha = L.hopur.x != null ? L.hopur.x : 0, hb = L.hopur.w != null ? ha + L.hopur.w : B;
        var dx = (ha + hb) / 2 - (gx0 + gx1) / 2;
        if (L.hopur.max_mm != null) dx = Math.max(-L.hopur.max_mm, Math.min(L.hopur.max_mm, dx));
        if (Math.abs(dx) > 0.001) {
          U.textar.forEach(function (tx) { tx.linur.forEach(function (ln) { ln.x += dx; }); });
          if (U.logo) U.logo.x += dx;
          if (U.takn) U.takn.x += dx;
          U.linur = U.linur.map(function (ln) { var n = afrit(ln); n.x1 += dx; n.x2 += dx; return n; });
          U.flatar = U.flatar.map(function (fl) { if (!fl.hopur) return fl; var n = afrit(fl); n.x += dx; return n; });
        }
        U.info.hopurFaersla = r3(dx);
      }
    }

    /* Lines that follow the content: { fylgja: 'texti' | 'allt', yfir, min_lengd }.
       'texti' spans the text ink (cap top of the first line to the descenders
       of the last), 'allt' also the logo and icon. Keeps a divider exactly as
       tall as what it divides, whatever the name and title do. */
    var kassi = function (medMyndum) {
      var y0 = Infinity, y1 = -Infinity;
      U.textar.forEach(function (tx) {
        var M = maelingar(tx.L), a = tx.linur[0], b = tx.linur[tx.linur.length - 1];
        var nidur = /[gjpqy\u00fe,;]/.test(b.t) ? M.desc * tx.s * 0.85 : 0;
        y0 = Math.min(y0, a.y - M.cap * tx.s); y1 = Math.max(y1, b.y + nidur);
      });
      if (medMyndum) {
        if (U.logo) { y0 = Math.min(y0, U.logo.y); y1 = Math.max(y1, U.logo.y + U.logo.h); }
        if (U.takn) { y0 = Math.min(y0, U.takn.y); y1 = Math.max(y1, U.takn.y + U.takn.s); }
      }
      return y0 < y1 ? { y0: y0, y1: y1 } : null;
    };
    U.linur = U.linur.map(function (ln) {
      if (!ln.fylgja) return ln;
      var k = kassi(ln.fylgja === "allt");
      if (!k) return ln;
      var yf = ln.yfir != null ? ln.yfir : 1, y0 = k.y0 - yf, y1 = k.y1 + yf, ml = ln.min_lengd || 0;
      if (y1 - y0 < ml) { var mid = (y0 + y1) / 2; y0 = mid - ml / 2; y1 = mid + ml / 2; }
      var n = afrit(ln); n.y1 = y0; n.y2 = y1; return n;
    });

    /* 4d. Safe area check on the real ink (accents, descenders) */
    var ins = L.orugg != null ? L.orugg : 1.2;
    if (U.rammi) [].concat(U.rammi).forEach(function (rm) { if (!rm.utskorid) ins = Math.max(ins, (rm.inset != null ? rm.inset : 1.5) + (rm.strik || 0.3) + 0.4); });
    var og = { x0: ins, y0: ins, x1: B - ins, y1: H - ins };
    U.textar.forEach(function (tx) {
      tx.linur.forEach(function (ln) {
        var b = blek(tx.L, ln.t, tx.s);
        if (ln.y - b.upp < og.y0 - 0.01 || ln.y + b.nidur > og.y1 + 0.01 || ln.x < og.x0 - 0.01 || ln.x + ln.w > og.x1 + 0.01) {
          if (!U.vand.some(function (q) { return q.kodi === "utan_oruggs"; })) vand.push(v("utan_oruggs"));
        }
      });
    });
    return U;
  }

  function stada(T, D, O) {
    var U = uppsetning(T, D, O), i, ok = true;
    for (i = 0; i < U.vand.length; i++) if (U.vand[i].stopp) ok = false;
    var r = { ok: ok, vandamal: U.vand, staerd: U.staerd, breiddMm: U.B, haedMm: U.H, skil: U.skil };
    for (var k in U.info) r[k] = U.info[k];
    return r;
  }

  /* Production spec for one badge (the hidden cart property _framleidsla).
     Compact shape shared with the planned SMVel core (arkitektur 7.2 / R6):
     template key and version, material and size, the texts as typed, and the
     fit the customer saw (font size, cap height, lines as drawn, squeeze,
     logo and icon boxes, all in mm from the top left corner). The production
     tool refits from the same engine version, so this is a record, not a
     drawing. O.logo: 'skra' | 'lysing' | null (what came with the order). */
  function framleidsla(T, D, O) {
    if (T && T.reitir) return framleidslaV(T, D, O);
    D = D || {}; O = O || {};
    var U = uppsetning(T, D, O), i = U.info, k = ["nafn"], r = [umbreyta(null, D.nafn)];
    if (umbreyta(null, D.titill)) { k.push("titill"); r.push(umbreyta(null, D.titill)); }
    var f = {};
    U.textar.forEach(function (tx) {
      var x = { mm: r3(tx.s), cap: r3(maelingar(tx.L).cap * tx.s), l: tx.linur.length };
      if (tx.sx < 0.999) x.sx = r3(tx.sx);
      if (tx.linur.length > 1) x.t = tx.linur.map(function (ln) { return ln.t; });
      f[tx.hlutur] = x;
    });
    if (U.logo) f.logo = { x: r3(U.logo.x), y: r3(U.logo.y), w: r3(U.logo.w), h: r3(U.logo.h) };
    if (U.takn) f.takn = { x: r3(U.takn.x), y: r3(U.takn.y), s: r3(U.takn.s) };
    if (i.hopurFaersla) f.hopur = i.hopurFaersla;
    return {
      v: "SMV1", vel: VERSION, s: "barmmerki." + (T.key || "") + "@" + (T.v || 1),
      e: { litur: litLykill(D.litur), staerd: U.staerd, b: U.B, h: U.H, horn: U.horn, rammi: !!U.rammi },
      sam: { takn: U.takn ? U.takn.key : null, logo: U.logo ? (O.logo || "skra") : null },
      k: k, r: [r], f: [f],
      vandamal: U.vand.map(function (q) { return q.kodi; })
    };
  }

  /* ------------------------------------------------------------------
     5. DRAWING (SVG string, millimetre viewBox)
     ------------------------------------------------------------------ */
  var NR = 0;
  function rrect(x, y, w, h, r, extra) {
    r = Math.max(0, Math.min(r || 0, w / 2, h / 2));
    return '<rect x="' + r3(x) + '" y="' + r3(y) + '" width="' + r3(w) + '" height="' + r3(h) + '" rx="' + r3(r) + '"' + (extra || "") + "/>";
  }

  /* Engraved look. Light faces: the house text-shadow (light below, dark
     above) scaled to mm. Dark face: a slightly soft white core with a thin
     shade inside the top edge where the black top layer overhangs. */
  function grofSia(id, Lt, B, H) {
    var f = '<filter id="' + id + 'g" filterUnits="userSpaceOnUse" x="-2" y="-2" width="' + (B + 4) + '" height="' + (H + 4) + '" color-interpolation-filters="sRGB">';
    if (Lt.ljos) {
      f += '<feOffset in="SourceAlpha" dy="0.075" result="o1"/><feGaussianBlur in="o1" stdDeviation="0.05" result="b1"/>' +
        '<feFlood flood-color="#ffffff" flood-opacity="0.5"/><feComposite in2="b1" operator="in" result="lj"/>' +
        '<feOffset in="SourceAlpha" dy="-0.075" result="o2"/><feGaussianBlur in="o2" stdDeviation="0.05" result="b2"/>' +
        '<feFlood flood-color="#000000" flood-opacity="0.28"/><feComposite in2="b2" operator="in" result="dk"/>' +
        '<feMerge><feMergeNode in="lj"/><feMergeNode in="dk"/><feMergeNode in="SourceGraphic"/></feMerge>';
    } else {
      f += '<feGaussianBlur in="SourceGraphic" stdDeviation="0.045" result="mj"/>' +
        '<feColorMatrix in="mj" type="matrix" values="1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 0.35 0" result="mj2"/>' +
        '<feOffset in="SourceAlpha" dy="0.055" result="o"/><feComposite in="SourceAlpha" in2="o" operator="out" result="rim"/>' +
        '<feGaussianBlur in="rim" stdDeviation="0.035" result="rb"/>' +
        '<feFlood flood-color="#000000" flood-opacity="0.24"/><feComposite in2="rb" operator="in" result="sk"/>' +
        '<feComposite in="sk" in2="SourceAlpha" operator="in" result="sk2"/>' +
        '<feMerge><feMergeNode in="mj2"/><feMergeNode in="SourceGraphic"/><feMergeNode in="sk2"/></feMerge>';
    }
    return f + "</filter>";
  }

  function taknSvg(key, x, y, s, lit, strikMm, O) {
    var sj = O && O.takn && O.takn[key];
    var k = s / 24, sw = (strikMm || Math.max(0.3, Math.min(0.5, s * 0.07))) / k;
    if (sj && /^\s*</.test(sj)) {
      var inn = String(sj).replace(/^[\s\S]*?<svg[^>]*>/i, "").replace(/<\/svg>\s*$/i, "");
      return '<svg x="' + r3(x) + '" y="' + r3(y) + '" width="' + r3(s) + '" height="' + r3(s) + '" viewBox="0 0 24 24" color="' + lit + '" fill="none" stroke="' + lit + '" stroke-width="' + r3(sw) + '" stroke-linecap="round" stroke-linejoin="round" overflow="visible">' + inn + "</svg>";
    }
    var d = TAKN[key] || [];
    return '<g transform="translate(' + r3(x) + " " + r3(y) + ") scale(" + r3(k) + ')" fill="none" stroke="' + lit + '" stroke-width="' + r3(sw) + '" stroke-linecap="round" stroke-linejoin="round">' +
      d.map(function (p) { return '<path d="' + p + '"/>'; }).join("") + "</g>";
  }

  function stadgengillSvg(g, lit) {
    var sw = Math.max(0.22, Math.min(0.35, g.h * 0.045));
    var s = rrect(g.x + sw / 2, g.y + sw / 2, g.w - sw, g.h - sw, Math.min(1.2, g.h * 0.18), ' fill="none" stroke="' + lit + '" stroke-width="' + r3(sw) + '"');
    var lh = g.h * 0.34, k = lh / 24, lw = 94 * k;
    if (lw > g.w * 0.72) { k = g.w * 0.72 / 94; lh = 24 * k; lw = 94 * k; }
    s += '<path d="' + LOGO_STAFIR + '" transform="translate(' + r3(g.x + (g.w - lw) / 2) + " " + r3(g.y + (g.h - lh) / 2) + ") scale(" + r3(k) + ')" fill="none" stroke="' + lit + '" stroke-width="' + r3(Math.max(0.26, sw) / k) + '" stroke-linecap="round" stroke-linejoin="round"/>';
    return s;
  }

  function textiSvg(tx, lit) {
    var L = tx.L, s = "";
    tx.linur.forEach(function (ln) {
      var att = ' font-family="' + esc("'" + (({"Dancing Script":"SM Skrift","IBM Plex Mono":"SM Mono"})[L.family] || L.family) + "', " + vara(L)) + '" font-size="' + r3(tx.s) + '" font-weight="' + (L.weight || 400) + '"' +
        (L.style === "italic" ? ' font-style="italic"' : "") + (L.tracking_em ? ' letter-spacing="' + r3(L.tracking_em * tx.s) + '"' : "") +
        ' fill="' + lit + '" text-rendering="geometricPrecision"';
      if (tx.sx < 0.999) s += '<text transform="translate(' + r3(ln.x) + " " + r3(ln.y) + ") scale(" + r3(tx.sx) + ' 1)" x="0" y="0"' + att + ">" + esc(ln.t) + "</text>";
      else s += '<text x="' + r3(ln.x) + '" y="' + r3(ln.y) + '"' + att + ">" + esc(ln.t) + "</text>";
    });
    return s;
  }

  function teikna(T, D, O) {
    if (T && T.reitir) return teiknaV(T, D, O);
    D = D || {}; O = O || {};
    var U = uppsetning(T, D, O);
    var id = "smb" + (++NR) + "-";
    var lk = litLykill(D.litur), Lt = LITIR[lk], lit = Lt.kjarni;
    var B = U.B, H = U.H, R = U.horn;
    var p = O.spassia != null ? O.spassia : 2.5;
    var efni = (O.efni || SMBarm.efni || {})[lk];
    var skuggi = O.skuggi !== false;
    var s = [], def = [], graf = [], ut = [], k;

    var vidd = O.pxmm ? ' width="' + r3((B + 2 * p) * O.pxmm) + '" height="' + r3((H + 2 * p) * O.pxmm) + '"' : ' width="100%"';
    var aria = O.aria != null ? O.aria : ORD.aria + (D.nafn ? ": " + D.nafn : "");
    s.push('<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="' + (-p) + " " + (-p) + " " + (B + 2 * p) + " " + (H + 2 * p) + '"' + vidd +
      (aria ? ' role="img" aria-label="' + esc(aria) + '"' : ' aria-hidden="true" focusable="false"') + ' data-smb-staerd="' + U.staerd + '" data-smb-litur="' + lk + '">');

    /* defs */
    def.push('<clipPath id="' + id + 'c">' + rrect(0, 0, B, H, R) + "</clipPath>");
    def.push(grofSia(id, Lt, B, H));
    if (skuggi) {
      def.push('<filter id="' + id + 's" filterUnits="userSpaceOnUse" x="' + (-p) + '" y="' + (-p) + '" width="' + (B + 2 * p) + '" height="' + (H + 2 * p) + '" color-interpolation-filters="sRGB">' +
        '<feGaussianBlur in="SourceAlpha" stdDeviation="0.55"/><feOffset dx="0.3" dy="0.55" result="a"/>' +
        '<feFlood flood-color="#000000" flood-opacity="0.24"/><feComposite in2="a" operator="in" result="sa"/>' +
        '<feGaussianBlur in="SourceAlpha" stdDeviation="0.14"/><feOffset dx="0.16" dy="0.2" result="b"/>' +
        '<feFlood flood-color="#000000" flood-opacity="0.38"/><feComposite in2="b" operator="in" result="sb"/>' +
        "<feMerge><feMergeNode in=\"sa\"/><feMergeNode in=\"sb\"/></feMerge></filter>");
    }
    /* top rim light: strongest along the top edge, gone by mid height */
    def.push('<linearGradient id="' + id + 'b" x1="0" y1="0" x2="0" y2="1">' +
      '<stop offset="0" stop-color="#ffffff" stop-opacity="' + Lt.glampi + '"/>' +
      '<stop offset="0.12" stop-color="#ffffff" stop-opacity="0"/></linearGradient>');
    /* bottom band: where the bevel catches the light (gold, black) or turns away (silver, white) */
    var bn = Lt.botn || { h: 0.4, lit: "#000000", op: 0 };
    def.push('<linearGradient id="' + id + 'n" gradientUnits="userSpaceOnUse" x1="0" y1="' + r3(H - bn.h) + '" x2="0" y2="' + H + '">' +
      '<stop offset="0" stop-color="' + bn.lit + '" stop-opacity="0"/>' +
      '<stop offset="0.75" stop-color="' + bn.lit + '" stop-opacity="' + r3(bn.op * 0.7) + '"/>' +
      '<stop offset="1" stop-color="' + bn.lit + '" stop-opacity="' + bn.op + '"/></linearGradient>');
    def.push('<filter id="' + id + 'k" color-interpolation-filters="sRGB"><feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"/></filter>');

    /* engraved elements (graf) and knocked-out elements (ut, drawn black in a mask) */
    function baeta(markup, utskorid) { (utskorid ? ut : graf).push(markup); }
    U.flatar.forEach(function (fl) {
      /* form 'hringur': a disc, or with strik an engraved ring (stroke inside the box) */
      if (fl.form === "hringur" && fl.strik) baeta('<circle cx="' + r3(fl.x + fl.w / 2) + '" cy="' + r3(fl.y + fl.h / 2) + '" r="' + r3(Math.min(fl.w, fl.h) / 2 - fl.strik / 2) + '" fill="none" stroke="' + lit + '" stroke-width="' + r3(fl.strik) + '"/>', fl.utskorid);
      else if (fl.form === "hringur") baeta('<circle cx="' + r3(fl.x + fl.w / 2) + '" cy="' + r3(fl.y + fl.h / 2) + '" r="' + r3(Math.min(fl.w, fl.h) / 2) + '" fill="' + lit + '"/>', fl.utskorid);
      else if (fl.d) baeta('<path d="' + esc(fl.d) + '" fill="' + lit + '"/>', fl.utskorid);
      else baeta(rrect(fl.x, fl.y, fl.w, fl.h, fl.horn || 0, ' fill="' + lit + '"'), fl.utskorid);
    });
    if (U.rammi) {
      [].concat(U.rammi).forEach(function (rm) {
        var i = rm.inset != null ? rm.inset : 1.5, sw = rm.strik || 0.3, rr = rm.horn != null ? rm.horn : Math.max(0.3, R - i);
        baeta(rrect(i + sw / 2, i + sw / 2, B - 2 * i - sw, H - 2 * i - sw, rr, ' fill="none" stroke="' + lit + '" stroke-width="' + r3(RAMMI_FORSKODUN_MM) + '"'), rm.utskorid);
      });
    }
    U.linur.forEach(function (ln) {
      baeta('<line x1="' + r3(ln.x1) + '" y1="' + r3(ln.y1) + '" x2="' + r3(ln.x2) + '" y2="' + r3(ln.y2) + '" stroke="' + lit + '" stroke-width="' + r3(ln.strik || 0.3) + '" stroke-linecap="' + (ln.endi || "butt") + '"/>', ln.utskorid);
    });
    if (U.logo) {
      var g = U.logo;
      if (g.stadgengill) baeta(stadgengillSvg(g, g.utskorid ? "#000000" : lit), g.utskorid);
      else {
        var img = '<image href="' + esc(g.mynd) + '" xlink:href="' + esc(g.mynd) + '" x="' + r3(g.x) + '" y="' + r3(g.y) + '" width="' + r3(g.w) + '" height="' + r3(g.h) + '" preserveAspectRatio="none"';
        if (g.utskorid) ut.push(img + ' filter="url(#' + id + 'k)"/>');
        else {
          def.push('<mask id="' + id + 'l" maskUnits="userSpaceOnUse" x="0" y="0" width="' + B + '" height="' + H + '">' + img + "/></mask>");
          graf.push('<rect x="' + r3(g.x) + '" y="' + r3(g.y) + '" width="' + r3(g.w) + '" height="' + r3(g.h) + '" fill="' + lit + '" mask="url(#' + id + 'l)"/>');
        }
      }
    }
    if (U.takn) {
      var tk = U.takn, tsl = O.takn && O.takn[tk.key];
      if (tsl && !/^\s*</.test(tsl)) {
        /* icon given as a URL: its alpha is the engraving */
        var tim = '<image href="' + esc(tsl) + '" xlink:href="' + esc(tsl) + '" x="' + r3(tk.x) + '" y="' + r3(tk.y) + '" width="' + r3(tk.s) + '" height="' + r3(tk.s) + '"';
        if (tk.utskorid) ut.push(tim + ' filter="url(#' + id + 'k)"/>');
        else {
          def.push('<mask id="' + id + 't" maskUnits="userSpaceOnUse" x="0" y="0" width="' + B + '" height="' + H + '" style="mask-type:alpha">' + tim + "/></mask>");
          graf.push('<rect x="' + r3(tk.x) + '" y="' + r3(tk.y) + '" width="' + r3(tk.s) + '" height="' + r3(tk.s) + '" fill="' + lit + '" mask="url(#' + id + 't)"/>');
        }
      } else baeta(taknSvg(tk.key, tk.x, tk.y, tk.s, tk.utskorid ? "#000000" : lit, tk.strik, O), tk.utskorid);
    }
    U.textar.forEach(function (tx) { baeta(textiSvg(tx, tx.utskorid ? "#000000" : lit), tx.utskorid); });
    if (ut.length) {
      def.push('<mask id="' + id + 'u" maskUnits="userSpaceOnUse" x="-1" y="-1" width="' + (B + 2) + '" height="' + (H + 2) + '">' +
        '<rect x="-1" y="-1" width="' + (B + 2) + '" height="' + (H + 2) + '" fill="#ffffff"/>' +
        ut.join("").replace(new RegExp('fill="' + lit + '"', "g"), 'fill="#000000"').replace(new RegExp('stroke="' + lit + '"', "g"), 'stroke="#000000"') + "</mask>");
    }

    s.push("<defs>" + def.join("") + "</defs>");
    /* body: shadow, a sliver of the cut edge, the photo face, engraving, bevel, edge */
    if (skuggi) s.push('<g filter="url(#' + id + 's)">' + rrect(0, 0, B, H, R, ' fill="' + Lt.flotur + '"') + "</g>");
    s.push('<g clip-path="url(#' + id + 'c)">');
    s.push(rrect(0, 0, B, H, 0, ' fill="' + Lt.flotur + '"'));
    if (efni) s.push('<image href="' + esc(efni) + '" xlink:href="' + esc(efni) + '" x="0" y="0" width="' + B + '" height="' + H + '" preserveAspectRatio="xMidYMid slice"/>');
    s.push('<g filter="url(#' + id + 'g)"><g' + (ut.length ? ' mask="url(#' + id + 'u)"' : "") + ">" + graf.join("") + "</g></g>");
    if (bn.op) s.push('<rect x="0" y="' + r3(H - bn.h) + '" width="' + B + '" height="' + r3(bn.h) + '" fill="url(#' + id + 'n)"/>');
    if (Lt.glampi) s.push(rrect(0, 0, B, H, R, ' fill="none" stroke="url(#' + id + 'b)" stroke-width="0.4"'));
    s.push("</g>");
    var li = Lt.lina || { lit: "#000000", op: 0.3 };
    s.push(rrect(0.03, 0.03, B - 0.06, H - 0.06, Math.max(0, R - 0.03), ' fill="none" stroke="' + li.lit + '" stroke-opacity="' + li.op + '" stroke-width="0.07"'));
    s.push("</svg>");
    return s.join("");
  }

  /* ------------------------------------------------------------------
     6. FONTS: Google Fonts URL and loading
     ------------------------------------------------------------------ */
  var EKKI_GOOGLE = { "Comic Sans MS": 1, "Arial": 1, "Helvetica": 1, "Georgia": 1, "Times New Roman": 1 };
  /* 07.10.2026: letur sniðmátanna er HÝST í þemanu (snippets/sm-vefletur.liquid, sömu bæti og sm-letur-<id>.json
     sem framleiðsluskráin notar). Enginn <link> til Google Fonts; hlada() bíður aðeins eftir
     document.fonts.load. leturSlod() er óbreytt (skilar Google-slóð ef einhver vill hana), en er ekki kölluð í hlada(). */
  var GOOGLE_LETUR = false;
  function leturListi(templates) {
    var ut = [];
    [].concat(templates || []).forEach(function (T) {
      var l = (T && T.letur) || {}, k;
      for (k in l) if (l[k] && l[k].family) ut.push(l[k]);
      /* 1.3.1: every font a customer can pick (T.letur_val, artwork labels) */
      var lv = (T && T.letur_val) || {}, f;
      for (f in lv) if (lv[f] && lv[f].letur) for (k in lv[f].letur) if (lv[f].letur[k] && lv[f].letur[k].family) ut.push(lv[f].letur[k]);
    });
    return ut;
  }
  function leturSlod(templates) {
    var fj = {}, rod = [];
    leturListi(templates).forEach(function (L) {
      if (EKKI_GOOGLE[L.family]) return;
      if (!fj[L.family]) { fj[L.family] = {}; rod.push(L.family); }
      fj[L.family][(L.style === "italic" ? 1 : 0) + "," + (L.weight || 400)] = 1;
    });
    if (!rod.length) return "";
    var hlutar = rod.map(function (fam) {
      var t = Object.keys(fj[fam]).map(function (k) { var a = k.split(","); return [+a[0], +a[1]]; });
      t.sort(function (a, b) { return a[0] - b[0] || a[1] - b[1]; });
      var ital = t.some(function (x) { return x[0] === 1; });
      var ax = ital ? "ital,wght@" + t.map(function (x) { return x[0] + "," + x[1]; }).join(";")
                    : "wght@" + t.map(function (x) { return x[1]; }).join(";");
      return "family=" + fam.replace(/ /g, "+") + ":" + ax;
    });
    return "https://fonts.googleapis.com/css2?" + hlutar.join("&") + "&display=swap";
  }
  /* Loads the fonts (and face photos) the templates need. Resolves when
     measuring is exact. opts: { letur: false } to skip adding the <link>,
     { efni: {...} } photos to preload. */
  function hlada(templates, O) {
    O = O || {};
    var slod = leturSlod(templates);
    var bida = [];
    if (GOOGLE_LETUR && slod && O.letur !== false) {
      var til = null, allir = doc.querySelectorAll("link[data-smb-letur]"), i;
      for (i = 0; i < allir.length; i++) if (allir[i].getAttribute("href") === slod) til = allir[i];
      if (!til) {
        til = doc.createElement("link"); til.rel = "stylesheet"; til.href = slod; til.setAttribute("data-smb-letur", "1");
        bida.push(new Promise(function (res) { til.onload = res; til.onerror = res; setTimeout(res, 8000); }));
        doc.head.appendChild(til);
      }
    }
    var efni = O.efni || SMBarm.efni || {};
    Object.keys(efni).forEach(function (k) {
      bida.push(new Promise(function (res) { var im = new Image(); im.onload = im.onerror = function () { res(); }; im.src = efni[k]; }));
    });
    return Promise.all(bida).then(function () {
      if (!doc.fonts || !doc.fonts.load) return true;
      return Promise.all(leturListi(templates).map(function (L) {
        return doc.fonts.load(leturStrengur(L, 20), SYNISTAFIR).catch(function () { return null; });
      })).then(function () { MAEL = {}; return doc.fonts.ready; }).then(function () { return true; });
    });
  }

  /* ------------------------------------------------------------------
     7. LOGO UPLOAD -> ENGRAVING MASK
     Adapted from the pet tag page (sm-gaeludyr: bakgrunnsLitur, grafaLogo).
     Output: white pixels with alpha = engraving, which teikna() tints with
     the core colour of the chosen face. PDF/AI/EPS cannot be drawn in the
     browser: done('stadgengill') and the badge shows an engraved LOGO box.
     ------------------------------------------------------------------ */
  function bakgrunnsLitur(p, w, h) {
    var bt = Math.max(1, Math.round(Math.min(w, h) * 0.02)), fotur = {}, alls = 0, gegns = 0, x, y;
    function tel(x, y) {
      var j = (y * w + x) * 4; alls++;
      if (p[j + 3] < 128) { gegns++; return; }
      var k = (p[j] >> 5) * 64 + (p[j + 1] >> 5) * 8 + (p[j + 2] >> 5), f = fotur[k] || (fotur[k] = [0, 0, 0, 0]);
      f[0]++; f[1] += p[j]; f[2] += p[j + 1]; f[3] += p[j + 2];
    }
    for (y = 0; y < h; y++) {
      if (y < bt || y >= h - bt) { for (x = 0; x < w; x++) tel(x, y); }
      else { for (x = 0; x < Math.min(bt, w); x++) tel(x, y); for (x = Math.max(bt, w - bt); x < w; x++) tel(x, y); }
    }
    var ogegns = alls - gegns;
    if (!alls || gegns > alls * 0.5 || !ogegns) return null;
    var best = null;
    for (var k in fotur) if (!best || fotur[k][0] > best[0]) best = fotur[k];
    if (!best || best[0] < ogegns * 0.5) return null;
    var bg = [best[1] / best[0], best[2] / best[0], best[3] / best[0]];
    var naer = 0, hvitir = 0, ogn = 0, n = w * h;
    for (var i = 0; i < n; i++) {
      var j = i * 4;
      if (p[j + 3] < 128) continue;
      ogn++;
      var dr = p[j] - bg[0], dg = p[j + 1] - bg[1], db = p[j + 2] - bg[2];
      if (0.299 * dr * dr + 0.587 * dg * dg + 0.114 * db * db < 48 * 48) naer++;
      else if (p[j] > 215 && p[j + 1] > 215 && p[j + 2] > 215) hvitir++;
    }
    if (!ogn || naer < ogn * 0.35 || naer < hvitir) return null;
    return bg;
  }

  function vinnaMynd(img, erSvg) {
    var w = img.naturalWidth || img.width || 600, h = img.naturalHeight || img.height || 300;
    var k = erSvg ? 900 / Math.max(w, h) : Math.min(1, 900 / Math.max(w, h));
    w = Math.max(1, Math.round(w * k)); h = Math.max(1, Math.round(h * k));
    var c = doc.createElement("canvas"); c.width = w; c.height = h;
    var cx = c.getContext("2d"); cx.drawImage(img, 0, 0, w, h);
    var d = cx.getImageData(0, 0, w, h), p = d.data, n = w * h, gegns = 0, i;
    for (i = 0; i < n; i++) if (p[i * 4 + 3] < 200) gegns++;
    var gegnsaett = gegns > n * 0.03, bg = gegnsaett ? null : bakgrunnsLitur(p, w, h);
    if (bg && (0.299 * bg[0] + 0.587 * bg[1] + 0.114 * bg[2]) / 255 >= 0.88 && Math.max(bg[0], bg[1], bg[2]) - Math.min(bg[0], bg[1], bg[2]) <= 30) bg = null;
    var dokk = new Float32Array(n), hist = new Uint32Array(256), histN = 0, ljosSum = 0, ljosN = 0;
    for (i = 0; i < n; i++) {
      var a = p[i * 4 + 3] / 255, lum = (0.299 * p[i * 4] + 0.587 * p[i * 4 + 1] + 0.114 * p[i * 4 + 2]) / 255;
      if (a > 0.5) { ljosSum += lum; ljosN++; }
      if (bg) {
        var dr = p[i * 4] - bg[0], dg = p[i * 4 + 1] - bg[1], db = p[i * 4 + 2] - bg[2];
        dokk[i] = Math.min(1, Math.sqrt(0.299 * dr * dr + 0.587 * dg * dg + 0.114 * db * db) / 255) * a;
      } else dokk[i] = (1 - lum) * a;
    }
    if (bg) {
      var utan = new Uint8Array(n), bid = new Int32Array(n), bn = 0;
      var hvitt = function (q) {
        var j = q * 4, r = p[j], gg = p[j + 1], b = p[j + 2];
        var dh = 0.299 * (255 - r) * (255 - r) + 0.587 * (255 - gg) * (255 - gg) + 0.114 * (255 - b) * (255 - b);
        var dr = r - bg[0], dg = gg - bg[1], db = b - bg[2];
        return dh < 0.299 * dr * dr + 0.587 * dg * dg + 0.114 * db * db;
      };
      var setja = function (q) { if (!utan[q] && hvitt(q)) { utan[q] = 1; bid[bn++] = q; } };
      for (var xx = 0; xx < w; xx++) { setja(xx); setja((h - 1) * w + xx); }
      for (var yy = 0; yy < h; yy++) { setja(yy * w); setja(yy * w + w - 1); }
      while (bn) {
        var q = bid[--bn], qx = q % w;
        dokk[q] = 0;
        if (qx > 0) setja(q - 1);
        if (qx < w - 1) setja(q + 1);
        if (q >= w) setja(q - w);
        if (q < n - w) setja(q + w);
      }
    }
    var bara = gegnsaett && ljosN && ljosSum / ljosN > 0.8;
    if (bara) for (i = 0; i < n; i++) dokk[i] = p[i * 4 + 3] / 255;
    else for (i = 0; i < n; i++) if (dokk[i] > 0.08) { hist[Math.min(255, (dokk[i] * 256) | 0)]++; histN++; }
    var topp = 1;
    if (!bara && histN) { var mark = histN * 0.9, upps = 0, hi; for (hi = 0; hi < 255; hi++) { upps += hist[hi]; if (upps > mark) break; } topp = Math.max(0.25, Math.min(1, (hi + 0.5) / 256)); }
    /* Laser engraving through a two-tone cap is on or off: a soft threshold
       keeps edges smooth but drops faint haze that would never engrave. */
    var minX = w, minY = h, maxX = -1, maxY = -1;
    for (i = 0; i < n; i++) {
      var vv = bara ? dokk[i] : (dokk[i] < 0.08 ? 0 : Math.min(1, dokk[i] / topp));
      vv = Math.max(0, Math.min(1, (vv - 0.2) / 0.18));
      p[i * 4] = 255; p[i * 4 + 1] = 255; p[i * 4 + 2] = 255; p[i * 4 + 3] = Math.round(vv * 255);
      if (vv > 0.1) { var x = i % w, y = (i / w) | 0; if (x < minX) minX = x; if (x > maxX) maxX = x; if (y < minY) minY = y; if (y > maxY) maxY = y; }
    }
    if (maxX < 0) return null;
    cx.putImageData(d, 0, 0);
    var cw = maxX - minX + 1, ch = maxY - minY + 1, c2 = doc.createElement("canvas");
    c2.width = cw; c2.height = ch; c2.getContext("2d").drawImage(c, minX, minY, cw, ch, 0, 0, cw, ch);
    return { mynd: c2.toDataURL("image/png"), r: cw / ch };
  }

  /* SVG files often lack width/height; give the root a pixel size from its viewBox */
  function svgMedStaerd(texti) {
    var m = /<svg\b[^>]*>/i.exec(texti);
    if (!m) return texti;
    var rot = m[0], vb = /viewBox\s*=\s*["']\s*([-\d.e]+)[\s,]+([-\d.e]+)[\s,]+([\d.e]+)[\s,]+([\d.e]+)/i.exec(rot);
    var w = /\swidth\s*=\s*["']([\d.]+)(px)?["']/i.exec(rot), h = /\sheight\s*=\s*["']([\d.]+)(px)?["']/i.exec(rot);
    if (w && h) return texti;
    if (!vb) return texti;
    var vw = +vb[3], vh = +vb[4], k = 900 / Math.max(vw, vh);
    var ny = rot.replace(/\s(width|height)\s*=\s*["'][^"']*["']/gi, "").replace(/<svg/i, '<svg width="' + Math.round(vw * k) + '" height="' + Math.round(vh * k) + '"');
    return texti.replace(rot, ny);
  }

  function grafaLogo(skra, lokid) {
    if (!skra || !win.URL || !URL.createObjectURL) { lokid(null); return; }
    var e = (/\.([a-z0-9]+)$/i.exec(skra.name || "") || [])[1];
    e = e ? e.toLowerCase() : "";
    if (!e && skra.type) e = (/image\/(svg|png|jpe?g|gif|webp|avif|bmp|heic|heif|tiff)/.exec(skra.type) || [])[1] || (/pdf|postscript|illustrator/.test(skra.type) ? "pdf" : "");
    /* PDF, AI, EPS, HEIC and TIFF cannot be drawn in every browser: the badge
       shows an engraved LOGO box and the file still goes with the order. */
    if (/^(pdf|ai|eps|ps|heic|heif|tif|tiff)$/.test(e)) { lokid("stadgengill"); return; }
    if (!/^(png|jpe?g|gif|webp|svg|avif|bmp)$/.test(e)) { lokid(null); return; }
    var buid = false, slod = null;
    function klara(r) { if (buid) return; buid = true; try { if (slod) URL.revokeObjectURL(slod); } catch (x) {} lokid(r); }
    function hlada2(blob, erSvg) {
      slod = URL.createObjectURL(blob);
      var img = new Image();
      img.onerror = function () { klara(null); };
      img.onload = function () { try { klara(vinnaMynd(img, erSvg)); } catch (x) { klara(null); } };
      img.src = slod;
    }
    if (e === "svg" && win.FileReader) {
      var fr = new FileReader();
      fr.onload = function () { hlada2(new Blob([svgMedStaerd(String(fr.result || ""))], { type: "image/svg+xml" }), true); };
      fr.onerror = function () { klara(null); };
      fr.readAsText(skra);
    } else hlada2(skra, false);
  }

  /* ------------------------------------------------------------------
     8. MULTI FIELD TEMPLATES (T.reitir), 1.3.0: verkamerki first
     Reuses the fonts, measuring, engraving look, logo mask and drawing
     helpers above. A badge template (no T.reitir) never reaches this
     code, so badge output is unchanged.
     ------------------------------------------------------------------ */

  /* Products: sizes as breidd x haed in mm, key "<breidd>x<haed>".
     Artwork labels use the door sign plates: 12 cm wide, 5, 7.5 or 10 cm high. */
  var VORUR = {
    verkamerki: {
      staerdir: { "120x50": { b: 120, h: 50 }, "120x75": { b: 120, h: 75 }, "120x100": { b: 120, h: 100 } },
      sjalfgefin: "120x75", efni: "tvilitt-hvitt"
    },
    /* 1.4.0: bag tags, from the owner's board (merkispjold/tillaga-eiganda):
       75 x 75 mm, corner radius R6, 1.6 mm two-tone or 3 mm solid matt acrylic, slot 16 x 5 mm with round
       ends, 6 mm from the top edge, for the steel wire loop with screw lock;
       no text under 3 mm cap height (owner 2026-09-27). lykkja = the wire
       loop drawn in the preview only (O.lykkja): an oval through the slot,
       the back half behind the plate, the front half over the bridge, and
       the screw lock on the back half. */
    toskumerki: {
      staerdir: { "75x75": { b: 75, h: 75 } },
      sjalfgefin: "75x75", efni: "tvilitt-hvitt",
      horn: 6, gat: { x: 29.5, y: 6, w: 16, h: 5, r: 2.5 }, lagmark_cap: 3, aria: "T\u00f6skumerki",
      lykkja: { ofan: 27, cx: 37.5, cy: -6.5, rx: 7, ry: 15, d: 1.3, las: { a: 205, l: 9, d: 3.2 } }
    }
  };

  /* Material registry, stable ids (arkitektur 5). Faces are photo crops of
     the door sign atlases per size (efni/<mynd>-<staerd>.webp); the safety
     colours use the ISO colours of the safety sign page (sm-oryggisskilti.js
     EFNI) on the light of the white acrylic photo until real photos exist.
     graf = how the letters look:
       'tvilitt' engraving opens the cap layer and shows the core (kjarni),
                 ljos = light face (bevel filter) or dark face (soft core);
       'merkt'   black laser marking on steel, on the surface, no depth;
       'grafid'  shallow engraving in the metal itself, tone in tone: the
                 letters are the same metal, a little darker and matt, with
                 a shaded upper wall and a light lower lip (op = strength).
     horn = corner radius mm: 0 on every material (owner 2026-09-27: all
     artwork labels have square corners, acrylic too; steel and brass come
     cut to size, so their outline is a placement guide, never a cut; the
     badges keep their own 3 mm HORN). kantur = the cut edge seen under the
     plate (two-tone acrylic shows its core colour there). lagmark_cap =
     cap height in mm under which small text gets a legibility warning. */
  var EFNI = {
    "tvilitt-gull":   { fj: "tvilitt", graf: "tvilitt", flotur: "#dcb381", kjarni: "#1a1815", ljos: true, horn: 0, kantur: "#2b2722", lagmark_cap: 1.6,
                        glampi: 0.5, botn: { h: 0.45, lit: "#fff3e4", op: 0.4 }, lina: { lit: "#8f6d47", op: 0.45 } },
    "tvilitt-silfur": { fj: "tvilitt", graf: "tvilitt", flotur: "#bcc6c1", kjarni: "#1a1815", ljos: true, horn: 0, kantur: "#2b2c2c", lagmark_cap: 1.6,
                        glampi: 0.35, botn: { h: 0.35, lit: "#000000", op: 0.1 }, lina: { lit: "#5c6461", op: 0.6 } },
    "tvilitt-svart":  { fj: "tvilitt", graf: "tvilitt", flotur: "#080b0a", kjarni: "#ffffff", ljos: false, horn: 0, kantur: "#e6e6e2", lagmark_cap: 1.6,
                        glampi: 0.22, botn: { h: 1.3, lit: "#a9bcc4", op: 0.12 }, lina: { lit: "#000000", op: 0.7 } },
    "tvilitt-hvitt":  { fj: "tvilitt", graf: "tvilitt", flotur: "#fcfbfc", kjarni: "#1a1815", ljos: true, horn: 0, kantur: "#24221f", lagmark_cap: 1.6,
                        glampi: 0.0, botn: { h: 0.35, lit: "#000000", op: 0.05 }, lina: { lit: "#8e8e8e", op: 0.75 } },
    "tvilitt-blatt":  { fj: "tvilitt", graf: "tvilitt", flotur: "#0a5d8a", kjarni: "#ffffff", ljos: false, horn: 0, kantur: "#eef0f2", lagmark_cap: 1.6,
                        glampi: 0.3, botn: { h: 0.8, lit: "#ffffff", op: 0.1 }, lina: { lit: "#042b40", op: 0.6 } },
    "tvilitt-rautt":  { fj: "tvilitt", graf: "tvilitt", flotur: "#df0e25", kjarni: "#ffffff", ljos: false, horn: 0, kantur: "#f0eded", lagmark_cap: 1.6,
                        glampi: 0.3, botn: { h: 0.8, lit: "#ffffff", op: 0.1 }, lina: { lit: "#6b0611", op: 0.6 } },
    "tvilitt-gult":   { fj: "tvilitt", graf: "tvilitt", flotur: "#fae63d", kjarni: "#1c1c1e", ljos: true, horn: 0, kantur: "#1f1f21", lagmark_cap: 1.6,
                        glampi: 0.45, botn: { h: 0.45, lit: "#fff8d6", op: 0.35 }, lina: { lit: "#857811", op: 0.5 } },
    "tvilitt-graent": { fj: "tvilitt", graf: "tvilitt", flotur: "#0f7f33", kjarni: "#ffffff", ljos: false, horn: 0, kantur: "#edf0ee", lagmark_cap: 1.6,
                        glampi: 0.3, botn: { h: 0.8, lit: "#ffffff", op: 0.1 }, lina: { lit: "#033b17", op: 0.6 } },
    /* supplier 917: white face, navy core (measured core #192757, cut edge #2f3d68) */
    "tvilitt-hvitt-blatt": { fj: "tvilitt", graf: "tvilitt", flotur: "#fcfbfc", kjarni: "#192757", ljos: true, horn: 0, kantur: "#2f3d68", lagmark_cap: 1.6,
                        glampi: 0.0, botn: { h: 0.35, lit: "#000000", op: 0.05 }, lina: { lit: "#8e8e8e", op: 0.75 } },
    "stal-svart":     { fj: "malmur", graf: "merkt", mynd: "stal", korn: 0.28, flotur: "#949595", kjarni: "#15171a", op: 0.93, horn: 0, kantur: "#5f6264", lagmark_cap: 1.6,
                        glampi: 0.35, botn: { h: 0.3, lit: "#000000", op: 0.2 }, lina: { lit: "#3c3f42", op: 0.75 } },
    "stal-grafid":    { fj: "malmur", graf: "grafid", mynd: "stal", korn: 0.28, flotur: "#949595", kjarni: "#2b2f33", op: 0.70, horn: 0, kantur: "#5f6264", lagmark_cap: 2.0,
                        glampi: 0.35, botn: { h: 0.3, lit: "#000000", op: 0.2 }, lina: { lit: "#3c3f42", op: 0.75 } },
    "messing-grafid": { fj: "malmur", graf: "grafid", mynd: "messing", korn: 0.22, flotur: "#ab954c", kjarni: "#4a3418", op: 0.70, horn: 0, kantur: "#6e5719", lagmark_cap: 2.0,
                        glampi: 0.4, botn: { h: 0.3, lit: "#000000", op: 0.22 }, lina: { lit: "#5a4612", op: 0.75 } },
    /* 1.4.0: solid matt acrylic (einlitt, bag tags). No second colour, so the
       engraving is the plate colour a shade lighter or darker, matt, with
       the tone in tone wall and lip of the metals ('grafid'): subtle, as
       the owner wants it. Faces are made from the white acrylic photo. */
    "einlitt-hvitt":     { fj: "einlitt", graf: "grafid", flotur: "#efefeb", kjarni: "#bdbdb6", op: 0.5, horn: 0, kantur: "#d3d3cc", lagmark_cap: 1.6,
                           glampi: 0.12, botn: { h: 0.35, lit: "#000000", op: 0.05 }, lina: { lit: "#8e8e8e", op: 0.7 } },
    "einlitt-svart":     { fj: "einlitt", graf: "grafid", flotur: "#252629", kjarni: "#8a8d92", op: 0.32, horn: 0, kantur: "#141517", lagmark_cap: 1.6,
                           glampi: 0.14, botn: { h: 1.0, lit: "#a9bcc4", op: 0.08 }, lina: { lit: "#000000", op: 0.7 } },
    "einlitt-ljosgratt": { fj: "einlitt", graf: "grafid", flotur: "#b7b9ba", kjarni: "#eef0f1", op: 0.72, horn: 0, kantur: "#9a9c9e", lagmark_cap: 1.6,
                           glampi: 0.2, botn: { h: 0.4, lit: "#000000", op: 0.08 }, lina: { lit: "#5f6264", op: 0.6 } }
  };
  var EFNI_ROD = ["tvilitt-hvitt", "tvilitt-svart", "tvilitt-gull", "tvilitt-silfur", "tvilitt-blatt", "tvilitt-rautt", "tvilitt-gult", "tvilitt-graent", "tvilitt-hvitt-blatt", "stal-svart", "stal-grafid", "messing-grafid", "einlitt-hvitt", "einlitt-svart", "einlitt-ljosgratt"];

  /* Customer facing words for this part, same rule as ORD above */
  ORD.mal = "is";
  ORD.efni = {
    "tvilitt-hvitt": "Hv\u00edtt", "tvilitt-svart": "Svart", "tvilitt-gull": "Gull", "tvilitt-silfur": "Silfur",
    "tvilitt-blatt": "Bl\u00e1tt", "tvilitt-rautt": "Rautt", "tvilitt-gult": "Gult", "tvilitt-graent": "Gr\u00e6nt",
    "tvilitt-hvitt-blatt": "Hv\u00edtt, bl\u00e1tt letur",
    "stal-svart": "St\u00e1l, sv\u00f6rt merking", "stal-grafid": "St\u00e1l, grafi\u00f0", "messing-grafid": "Messing, grafi\u00f0",
    "einlitt-hvitt": "Hv\u00edtt, matt", "einlitt-svart": "Svart, matt", "einlitt-ljosgratt": "Lj\u00f3sgr\u00e1tt, matt"
  };
  ORD.efniLysing = {
    "tvilitt-hvitt": "Hv\u00edtt akr\u00fdl, svartir stafir", "tvilitt-svart": "Svart akr\u00fdl, hv\u00edtir stafir",
    "tvilitt-gull": "Gyllt akr\u00fdl, svartir stafir", "tvilitt-silfur": "Silfra\u00f0 akr\u00fdl, svartir stafir",
    "tvilitt-blatt": "Bl\u00e1tt akr\u00fdl, hv\u00edtir stafir", "tvilitt-rautt": "Rautt akr\u00fdl, hv\u00edtir stafir",
    "tvilitt-gult": "Gult akr\u00fdl, svartir stafir", "tvilitt-graent": "Gr\u00e6nt akr\u00fdl, hv\u00edtir stafir",
    "tvilitt-hvitt-blatt": "Hv\u00edtt akr\u00fdl, d\u00f6kkbl\u00e1ir stafir",
    "stal-svart": "St\u00e1l, stafirnir merktir svartir", "stal-grafid": "St\u00e1l, stafirnir grafnir \u00ed st\u00e1li\u00f0",
    "messing-grafid": "Messing, stafirnir grafnir \u00ed messinginn",
    "einlitt-hvitt": "Hv\u00edtt matt akr\u00fdl, grafi\u00f0 t\u00f3n \u00ed t\u00f3n", "einlitt-svart": "Svart matt akr\u00fdl, grafi\u00f0 t\u00f3n \u00ed t\u00f3n",
    "einlitt-ljosgratt": "Lj\u00f3sgr\u00e1tt matt akr\u00fdl, grafi\u00f0 t\u00f3n \u00ed t\u00f3n"
  };
  ORD.staerdirV = { "120x50": "5 \u00d7 12 cm", "120x75": "7,5 \u00d7 12 cm", "120x100": "10 \u00d7 12 cm", "75x75": "7,5 \u00d7 7,5 cm" };
  ORD.ariaV = "Skilti fyrir listaverk";
  ORD.vandamal.vantar = "\u00deennan reit \u00fearf a\u00f0 fylla \u00fat";
  ORD.vandamal.of_langt = "Textinn er of langur fyrir \u00feessa st\u00e6r\u00f0";
  ORD.vandamal.sest_ekki = "\u00deessi reitur s\u00e9st ekki \u00e1 merkinu \u00ed \u00feessari st\u00e6r\u00f0";
  ORD.vandamal.smatt = "Letri\u00f0 ver\u00f0ur mj\u00f6g sm\u00e1tt";
  STOPP.vantar = 1; STOPP.of_langt = 1;
  /* 1.3.1: fixed Icelandic cart keys (the production reads one language) */
  ORD.eigV = { utlit: "\u00datlit", letur: "Leturger\u00f0" };
  /* 1.3.1: production file header lines (for the workshop, not customers) */
  ORD.framV = {
    efni: "Efni", staerd: "St\u00e6r\u00f0", plata: "Plata", logo: "Logo", reitur: "Logo-reitur",
    akryl: "Skorin \u00far tv\u00edlitu akr\u00fdli, 1,6 mm, bein horn (SKERA)",
    malmur: "Kemur tilskorin, bein horn. Gr\u00e6na \u00fatl\u00ednan (UTLINA) er a\u00f0eins til a\u00f0 stilla upp, ekki skera",
    logoMynd: "Grafi\u00f0 eftir skr\u00e1 vi\u00f0skiptavinar",
    logoSkra: "Skr\u00e1in fylgir p\u00f6ntuninni en s\u00e9st ekki \u00ed forsko\u00f0un. Settu hana \u00ed strika\u00f0a reitinn \u00ed GRAFA-MYND",
    logoLysing: "Engin skr\u00e1, l\u00fdsing vi\u00f0skiptavinar: {t}. Settu logoi\u00f0 \u00ed strika\u00f0a reitinn \u00ed GRAFA-MYND",
    logoSidar: "Engin skr\u00e1 og engin l\u00fdsing. Settu logoi\u00f0 \u00ed strika\u00f0a reitinn \u00ed GRAFA-MYND",
    reiturTexti: "x {x}, y {y}, {w} \u00d7 {h} mm (mesta pl\u00e1ss {mw} \u00d7 {mh} mm)",
    /* 1.4.0 bag tags: per material family (fj) */
    plataVara: {
      toskumerki: {
        tvilitt: "Skorin \u00far tv\u00edlitu akr\u00fdli, 1,6 mm, horn R6 og rauf 16 \u00d7 5 mm (SKERA)",
        einlitt: "Skorin \u00far einlitu m\u00f6ttu akr\u00fdli, 3 mm, horn R6 og rauf 16 \u00d7 5 mm (SKERA)"
      }
    }
  };

  function has(o, k) { return Object.prototype.hasOwnProperty.call(o, k); }
  /* Text in the current language from a per language object or a string */
  function tx(o) { return o == null ? "" : (typeof o === "string" ? o : (o[ORD.mal] || o.is || "")); }
  function varaAf(T) { return VORUR[T && T.vara] || VORUR.verkamerki; }
  /* '120x75', '7,5 x 12 cm', '12 x 7,5 cm', '75x120mm' -> '120x75' (width is the longer side) */
  function staerdLykillV(x, P) {
    P = P || VORUR.verkamerki;
    var s = String(x == null ? "" : x).toLowerCase().replace(/\s+/g, "").replace(/\u00d7/g, "x");
    if (P.staerdir[s]) return s;
    var m = /^(\d+(?:[.,]\d+)?)x(\d+(?:[.,]\d+)?)(mm|cm)?$/.exec(s);
    if (!m) return P.sjalfgefin;
    var a = parseFloat(m[1].replace(",", ".")), b = parseFloat(m[2].replace(",", "."));
    var k = m[3] === "mm" || (!m[3] && Math.max(a, b) > 20) ? 1 : 10;
    a = Math.round(a * k); b = Math.round(b * k);
    var lyk = Math.max(a, b) + "x" + Math.min(a, b);
    return P.staerdir[lyk] ? lyk : P.sjalfgefin;
  }
  /* 'tvilitt-gull', or the label 'Gull' / 'St\u00e1l, grafi\u00f0'; unknown -> white */
  function efniLykill(x) {
    var k = String(x || "").replace(/^\s+|\s+$/g, "");
    if (EFNI[k]) return k;
    var lag = k.toLowerCase(), i;
    for (i = 0; i < EFNI_ROD.length; i++) if (String(ORD.efni[EFNI_ROD[i]]).toLowerCase() === lag) return EFNI_ROD[i];
    return VORUR.verkamerki.efni;
  }
  function gildi(D, r) { return umbreyta(null, D[r]); }
  /* 1.3.1: font key from 'plex', the name 'IBM Plex Mono' or a Shopify value;
     unknown -> the look's own font (T.letur_sjalfgefid) */
  function leturLykill(T, x) {
    var lv = T && T.letur_val, f;
    if (!lv) return null;
    var k = String(x == null ? "" : x).toLowerCase().replace(/[^a-z0-9]/g, "");
    if (k && has(lv, k)) return k;
    for (f in lv) if (has(lv, f) && k && String(tx(lv[f].heiti)).toLowerCase().replace(/[^a-z0-9]/g, "") === k) return f;
    return has(lv, T.letur_sjalfgefid) ? T.letur_sjalfgefid : null;
  }
  function stofn(t, v) { return String(t).replace(/\{(\w+)\}/g, function (m, n) { return v[n] != null ? v[n] : m; }); }
  function vV(kodi, T, reitur, rod) {
    var R = reitur && T.reitir && T.reitir[reitur], t = "";
    if (R && R.ord && R.ord[kodi]) t = tx(R.ord[kodi]);
    if (!t) t = (ORD.vandamal && ORD.vandamal[kodi]) || kodi;
    return { kodi: kodi, texti: t, stopp: !!STOPP[kodi], reitur: reitur || null, rod: rod || null };
  }

  /* ---- rich rows: several fields and fonts on one line ----
     A row is { hlutar: [ {r: field, letur}, {t: ', ', skil: 'halda'|'sleppa'}, ... ],
     letur, max_linur, regla: 'malsgrein' (paragraph), brot: 'skil' (break at
     separators first) }. A separator is drawn only between two filled fields;
     at a line break 'sleppa' drops it ("Ol\u00eda \u00e1 striga \u00b7 100 \u00d7 80 cm") and
     'halda' keeps its mark at the end of the line ("Haustlj\u00f3s yfir Reykjanesi,"). */
  function einingar(R, D, LET) {
    var hl = R.hlutar || [{ r: R.id }], spans = [], i, j;
    for (i = 0; i < hl.length; i++) {
      var h = hl[i], L = LET[h.letur || R.letur] || LET[R.letur];
      if (h.r) {
        var t = gildi(D, h.r);
        if (t) spans.push({ t: umbreyta(L, (h.forskeyti || "") + t + (h.vidskeyti || "")), L: L, k: h.k || 1, reitur: h.r });
      }
      else if (h.fast) spans.push({ t: umbreyta(L, h.fast), L: L, k: h.k || 1 });
      else if (h.t) spans.push({ t: h.t, L: L, k: h.k || 1, skil: h.skil || "sleppa" });
    }
    var ut = [];
    for (i = 0; i < spans.length; i++) {
      if (spans[i].skil) {
        var eftir = false;
        for (j = i + 1; j < spans.length; j++) if (!spans[j].skil) { eftir = true; break; }
        if (!ut.length || ut[ut.length - 1].skil || !eftir) continue;
      }
      ut.push(spans[i]);
    }
    var units = [];
    ut.forEach(function (sp) {
      if (sp.skil) { units.push({ t: sp.t, L: sp.L, k: sp.k, skil: sp.skil }); return; }
      sp.t.split(" ").forEach(function (w, n) { units.push({ t: (n ? " " : "") + w, L: sp.L, k: sp.k, reitur: sp.reitur }); });
    });
    return units;
  }
  function brotStadir(units) {
    var b = [], i;
    for (i = 1; i < units.length; i++) if (/^ /.test(units[i].t) || units[i - 1].skil || units[i].skil === "sleppa") b.push(i);
    return b;
  }
  /* Units a..b-1 as one line: pieces of the same font merged, edges trimmed */
  function lina(units, a, b) {
    var p = [], i;
    for (i = a; i < b; i++) {
      var u = units[i], t = u.t;
      if (u.skil === "sleppa" && (i === a || i === b - 1)) continue;
      if (u.skil && i === b - 1) t = t.replace(/\s+$/, "");
      if (!p.length) t = t.replace(/^\s+/, "");
      if (!t) continue;
      var sid = p[p.length - 1];
      if (sid && sid.L === u.L && sid.k === u.k) sid.t += t; else p.push({ t: t, L: u.L, k: u.k });
    }
    return p;
  }
  /* Width at font size 1 mm (tracking inside pieces, and after a piece that has it) */
  function linuBreidd(p) {
    var w = 0, i;
    for (i = 0; i < p.length; i++) {
      w += breidd(p[i].L, p[i].t, p[i].k);
      if (i < p.length - 1) w += (p[i].L.tracking_em || 0) * p[i].k;
    }
    return w;
  }
  /* Balanced split into n lines: minimise the longest line (DP over the allowed breaks) */
  function bestaSkipting(units, n, leyfd) {
    if (leyfd.length < n - 1) return null;
    var pts = [0].concat(leyfd).concat([units.length]), K = pts.length, W = {}, f = [], ff = [], j, c, q;
    function wid(a, b) { var key = a + ":" + b; if (W[key] == null) W[key] = linuBreidd(lina(units, pts[a], pts[b])); return W[key]; }
    for (c = 0; c <= n; c++) { f[c] = []; ff[c] = []; for (j = 0; j < K; j++) f[c][j] = Infinity; }
    f[0][0] = 0;
    for (c = 1; c <= n; c++) for (j = 1; j < K; j++) for (q = 0; q < j; q++) {
      if (f[c - 1][q] === Infinity) continue;
      var val = Math.max(f[c - 1][q], wid(q, j));
      if (val < f[c][j]) { f[c][j] = val; ff[c][j] = q; }
    }
    if (f[n][K - 1] === Infinity) return null;
    var linur = [], jj = K - 1;
    for (c = n; c >= 1; c--) { var q2 = ff[c][jj]; linur.unshift(lina(units, pts[q2], pts[jj])); jj = q2; }
    return { linur: linur, m: f[n][K - 1] };
  }
  /* Greedy wrap (paragraphs, ragged edge) at a line width of 'limit' (mm at size 1) */
  function vefja(units, leyfd, limit) {
    var linur = [], a = 0, bset = {}, i;
    leyfd.forEach(function (b) { bset[b] = 1; });
    while (a < units.length) {
      var best = -1;
      for (i = a + 1; i <= units.length; i++) {
        if (i < units.length && !bset[i]) continue;
        if (linuBreidd(lina(units, a, i)) <= limit + 1e-9) best = i; else break;
      }
      if (best < 0) for (i = a + 1; i <= units.length; i++) if (i === units.length || bset[i]) { best = i; break; }
      linur.push(lina(units, a, best)); a = best;
    }
    return linur;
  }
  /* Fit a rich row into width w (mm). Policy (arkitektur 6.3): largest size up
     to max_mm; below skipta_undir_mm wrap into up to max_linur lines
     (balanced; paragraphs greedy); then shrink to min_mm; then squeeze to 85 %;
     then not ok. Returns { linur: [[piece]], s, sx, ok, mw } */
  function fittaRik(units, w, Lr, R) {
    var min = Lr.min_mm || 1, max = Lr.max_mm || 10, maxL = R.max_linur || 1;
    var leyfd = brotStadir(units), eitt = [lina(units, 0, units.length)], res, i;
    if (R.regla === "malsgrein") {
      var lin = vefja(units, leyfd, w / max);
      if (lin.length <= maxL) res = { linur: lin, s: max };
      else {
        lin = vefja(units, leyfd, w / min);
        if (lin.length > maxL) res = { linur: lin, s: min, of: true };
        else {
          var lo = min, hi = max;
          for (i = 0; i < 18; i++) { var mid = (lo + hi) / 2; if (vefja(units, leyfd, w / mid).length <= maxL) lo = mid; else hi = mid; }
          res = { linur: vefja(units, leyfd, w / lo), s: lo };
        }
      }
    } else {
      var s1 = Math.min(max, w / Math.max(1e-6, linuBreidd(eitt[0])));
      res = { linur: eitt, s: s1 };
      var undir = Math.max(Lr.skipta_undir_mm || max, min);
      if (s1 < undir - 1e-6 && maxL > 1 && leyfd.length) {
        var skilB = leyfd.filter(function (b) { return units[b - 1].skil || units[b].skil; });
        for (var n = 2; n <= maxL; n++) {
          var sk = null, sk2 = bestaSkipting(units, n, leyfd);
          if (R.brot === "skil" && skilB.length >= n - 1) sk = bestaSkipting(units, n, skilB);
          if (sk && sk2 && Math.min(max, w / sk.m) < Math.min(max, w / sk2.m) * 0.85) sk = null;
          sk = sk || sk2;
          if (!sk) break;
          var sn = Math.min(max, w / sk.m);
          if (sn > res.s + 1e-6) res = { linur: sk.linur, s: sn };
          if (sn >= undir - 1e-6) break;
        }
      }
    }
    var mw = 0;
    res.linur.forEach(function (p) { mw = Math.max(mw, linuBreidd(p)); });
    res.mw = mw; res.sx = 1; res.ok = !res.of;
    if (res.s < min) res.s = min;
    if (mw * res.s > w + 1e-6) { res.sx = w / (mw * res.s); if (res.sx < 0.85 - 1e-6) res.ok = false; }
    return res;
  }
  /* 1.3.1: wrap a rich row at a GIVEN size s (a flow grid shares one size):
     the fewest lines, up to max_linur, that fit the width; else the
     max_linur split squeezed (not ok under 85 %) */
  function fittaVidStaerd(units, w, Lr, R, s) {
    var maxL = R.max_linur || 1, leyfd = brotStadir(units), eitt = lina(units, 0, units.length), best = { linur: [eitt], m: linuBreidd(eitt) }, n;
    if (best.m * s > w + 1e-6 && leyfd.length) {
      var skilB = leyfd.filter(function (b) { return units[b - 1].skil || units[b].skil; });
      for (n = 2; n <= maxL; n++) {
        var sk = R.brot === "skil" && skilB.length >= n - 1 ? bestaSkipting(units, n, skilB) : null, sk2 = bestaSkipting(units, n, leyfd);
        if (!sk || (sk2 && sk.m * s > w + 1e-6 && sk2.m < sk.m)) sk = sk2;
        if (!sk) break;
        if (sk.m < best.m) best = sk;
        if (best.m * s <= w + 1e-6) break;
      }
    }
    var res = { linur: best.linur, s: s, sx: 1, ok: true, mw: best.m };
    if (best.m * s > w + 1e-6) { res.sx = w / (best.m * s); if (res.sx < 0.85 - 1e-6) res.ok = false; }
    return res;
  }
  function haedRadar(Lr, s, n) { var M = maelingar(Lr); return M.cap * s + (n - 1) * (Lr.linubil || 1.2) * s; }

  /* Frame geometry (1.3.1): inset, or inset_x / inset_y (the door sign
     frame is 2.2 mm from the sides and 2.5 mm from top and bottom).
     'lina' = one scored line ON the inset, as in the door sign file;
     'grafa' = the old engraved band sw wide from the inset inwards; since
     2026-09-29 it is made as one score line on the band's centre line.
     x, y, w, h = the centre line; innriX / innriY = the old inner edge
     (kept, so text keeps its place). */
  function rammiGeo(rm, B, H, horn) {
    var ix = rm.inset_x != null ? rm.inset_x : (rm.inset != null ? rm.inset : 3), iy = rm.inset_y != null ? rm.inset_y : (rm.inset != null ? rm.inset : 3);
    var sw = rm.strik || 0.25, lina = (rm.vinnsla || "lina") === "lina", rr = rm.horn != null ? rm.horn : Math.max(0, (horn || 0) - Math.min(ix, iy));
    var mx = lina ? ix : ix + sw / 2, my = lina ? iy : iy + sw / 2;
    return { lina: lina, sw: sw, r: rr, ix: ix, iy: iy, x: mx, y: my, w: B - 2 * mx, h: H - 2 * my, innriX: mx + sw / 2, innriY: my + sw / 2 };
  }

  /* ---- layout ---- */
  function uppsetningV(T, D, O) {
    D = D || {}; O = O || {};
    var P = varaAf(T), sk = staerdLykillV(D.staerd, P), S = P.staerdir[sk], B = S.b, H = S.h;
    var ek = efniLykill(D.efni), E = EFNI[ek], vand = [];
    var grunnur = (T.staerdir || {})[sk];
    if (!grunnur) { vand.push(v("staerd_vantar")); grunnur = {}; }
    var reitir = T.reitir || {}, rk;
    var logo = D.logo || null;
    if (logo && logo !== "stadgengill" && !(logo.mynd && logo.r)) logo = null;
    var skil = { medLogo: !!logo, anLogos: !logo, breittLogo: !!(logo && logo !== "stadgengill" && logo.r >= 2.4) };
    for (rk in reitir) if (has(reitir, rk)) { var g0 = gildi(D, rk); skil["med_" + rk] = !!g0; skil["an_" + rk] = !g0; }
    var L = beitaEf(grunnur, skil);
    /* Font choice (1.3.1): the look's own font uses T.letur and the size
       overrides above; another font brings its own complete table
       (letur_val[f].letur + .staerdir[size].letur) and may add long text
       rules (.radir, .staerdir[size].radir). */
    var lk = leturLykill(T, D.letur), LS = lk ? T.letur_val[lk] : null, LET = {}, RAD = {}, k;
    var eiginn = !(LS && LS.letur), LSs = (LS && LS.staerdir && LS.staerdir[sk]) || {};
    var LB = eiginn ? (T.letur || {}) : LS.letur, LBs = eiginn ? (L.letur || {}) : (LSs.letur || {});
    var RS = LS ? blanda(LS.radir || {}, LSs.radir || {}) : {};
    for (k in LB) if (has(LB, k)) LET[k] = blanda(LB[k], LBs[k] || {});
    for (k in T.radir) if (has(T.radir, k)) { RAD[k] = blanda(blanda(T.radir[k], (L.radir && L.radir[k]) || {}), RS[k] || {}); RAD[k].id = k; }
    /* Material floor: no size may put the cap height under the material's
       legibility minimum (1.6 mm acrylic and black marked steel, 2 mm
       engraved steel and brass), whatever the font. Long text then wraps,
       squeezes or stops instead of getting smaller. */
    for (k in LET) if (has(LET, k)) {
      var golf = Math.ceil(Math.max(E.lagmark_cap || 1.6, P.lagmark_cap || 0) / (maelingar(LET[k]).cap || 0.7) * 1000) / 1000;
      if (!(LET[k].min_mm >= golf)) LET[k].min_mm = golf;
      if (LET[k].max_mm != null && LET[k].max_mm < LET[k].min_mm) LET[k].max_mm = LET[k].min_mm;
    }
    for (rk in reitir) if (has(reitir, rk) && reitir[rk].skylda && !gildi(D, rk)) vand.push(vV("vantar", T, rk));

    var U = {
      vara: T.vara || "verkamerki", staerd: sk, efni: ek, letur: lk, B: B, H: H, horn: P.horn != null ? P.horn : (E.horn != null ? E.horn : 0),
      rammi: L.rammi || null, linur: [].concat(L.linur || []), flatar: [].concat(L.flatar || []),
      textar: [], logo: null, takn: null, vand: vand, skil: skil,
      info: { radir: {}, logoHaedMm: 0, logoBreiddMm: 0 }
    };
    if (P.gat) U.gat = P.gat;
    U.snidLinur = U.linur.length; /* the template's own dividers come first in U.linur */
    if (L.grafik) U.grafik = [].concat(L.grafik);
    var synd = {};
    function fyrstiReitur(R) { var h = (R.hlutar || [{ r: R.id }]).filter(function (x) { return x.r; })[0]; return h ? h.r : R.id; }
    function merkjaSynd(R) { (R.hlutar || [{ r: R.id }]).forEach(function (x) { if (x.r) synd[x.r] = 1; }); }
    function textaUtV(id, R, Lr, f, x0, w, jofnun, topp) {
      var M = maelingar(Lr), lb = Lr.linubil || 1.2, linur = [];
      f.linur.forEach(function (p, i) {
        var wl = linuBreidd(p) * f.s * f.sx, x = jafna(jofnun, x0, w, wl), y = topp + M.cap * f.s + i * lb * f.s;
        var hl = [], dx = 0;
        p.forEach(function (h, j) {
          var ww = breidd(h.L, h.t, h.k * f.s);
          hl.push({ t: h.t, L: h.L, s: h.k * f.s, dx: dx, w: ww });
          dx += ww + (j < p.length - 1 ? (h.L.tracking_em || 0) * h.k * f.s : 0);
        });
        linur.push({ x: x, y: y, w: wl, sx: f.sx, hlutar: hl });
      });
      var tx0 = { rik: true, rod: id, L: Lr, s: f.s, sx: f.sx, linur: linur };
      U.textar.push(tx0);
      U.info.radir[id] = { mm: r3(f.s), cap: r3(M.cap * f.s), linur: f.linur.length, sx: r3(f.sx), ok: f.ok };
      var rt = fyrstiReitur(R);
      if (!f.ok) vand.push(vV("of_langt", T, rt, id));
      else if (M.cap * f.s < (Lr.lagmark_cap || Math.max(E.lagmark_cap || 1.6, P.lagmark_cap || 0)) - 1e-6) vand.push(vV("smatt", T, rt, id));
      return tx0;
    }
    function setjaLogoV(x, y, w, h, svaedi) {
      if (logo === "stadgengill") U.logo = { stadgengill: true, x: x, y: y, w: w, h: h };
      else U.logo = { mynd: logo.mynd, x: x, y: y, w: w, h: h };
      U.logo.svaedi = svaedi || { w: w, h: h };
      U.info.logoHaedMm = r3(h); U.info.logoBreiddMm = r3(w);
      if (h < 5 && w < 14) vand.push(vV("logo_litid", T, "logo"));
    }
    var logoSett = false;

    /* a) fixed cells (holf): a row or the logo in its own box */
    var holf = L.holf || {};
    Object.keys(holf).forEach(function (id) {
      var box = holf[id], jof = box.jofnun || "midja";
      if (id === "logo") {
        if (!logo) return;
        var fl = fitLogo(box, logo === "stadgengill" ? 2.2 : logo.r);
        var ly = (box.lodrett || "midja") === "efst" ? box.y : box.y + (box.h - fl.h) / 2;
        setjaLogoV(jafna(jof, box.x, box.w, fl.w), ly, fl.w, fl.h, { w: box.w, h: box.h }); logoSett = true;
        return;
      }
      var R = RAD[id]; if (!R) return;
      merkjaSynd(R);
      var Lr = LET[R.letur], u = einingar(R, D, LET);
      if (!u.length) return;
      var f = fittaRik(u, box.w, Lr, R), hh = haedRadar(Lr, f.s, f.linur.length);
      if (hh > box.h + 1e-6) {
        f.s = Math.max(Lr.min_mm || 1, f.s * box.h / hh);
        hh = haedRadar(Lr, f.s, f.linur.length);
        if (hh > box.h + 0.05) { f.ok = false; }
      }
      var lod = box.lodrett || "midja";
      var topp = box.grunnlina != null ? box.grunnlina - maelingar(Lr).cap * f.s : (lod === "efst" ? box.y : lod === "nedst" ? box.y + box.h - hh : box.y + (box.h - hh) / 2);
      textaUtV(id, R, Lr, f, box.x, box.w, jof, topp);
    });

    /* b) flow grid (grind): the filled fields fill the cells in order */
    var G = L.grind;
    if (G) {
      var dk = G.dalkar || 2, bx = G.bil_x != null ? G.bil_x : 3, by = G.bil_y != null ? G.bil_y : 2, cw = (G.w - (dk - 1) * bx) / dk, cells = [];
      (G.rod || []).forEach(function (id) {
        var R = RAD[id]; if (!R) return; merkjaSynd(R);
        var u = einingar(R, D, LET); if (!u.length) return;
        var Lr = LET[R.letur], f = fittaRik(u, cw, Lr, R);
        cells.push({ id: id, R: R, Lr: Lr, f: f, s0: f.s, u: u });
      });
      /* one font size for the whole grid (1.3.1): every cell takes the
         smallest fitted size and is wrapped again at that size */
      if (cells.length > 1) {
        var sG = Infinity;
        cells.forEach(function (cl) { sG = Math.min(sG, cl.f.s); });
        cells.forEach(function (cl) { cl.f = fittaVidStaerd(cl.u, cw, cl.Lr, cl.R, sG); cl.s0 = sG; });
      }
      var nrod = Math.ceil(cells.length / dk);
      var gHaed = function (fk) {
        var t = 0, r, c;
        for (r = 0; r < nrod; r++) {
          var mh = 0;
          for (c = 0; c < dk; c++) {
            var cl = cells[r * dk + c]; if (!cl) continue;
            cl.hs = Math.max(cl.Lr.min_mm || 1, cl.s0 * fk);
            cl.h = haedRadar(cl.Lr, cl.hs, cl.f.linur.length); mh = Math.max(mh, cl.h);
          }
          t += mh + (r ? by : 0);
        }
        return t;
      };
      if (cells.length) {
        var fk = 1, hg = gHaed(1);
        if (hg > G.h + 1e-6) { var lo = 0, hi = 1, j; for (j = 0; j < 24; j++) { var m2 = (lo + hi) / 2; if (gHaed(m2) > G.h) hi = m2; else lo = m2; } fk = lo; hg = gHaed(fk); if (hg > G.h + 0.05) vand.push(v("of_hatt")); }
        var yg = (G.lodrett || "midja") === "efst" ? G.y : G.y + (G.h - hg) / 2, r2, c2;
        for (r2 = 0; r2 < nrod; r2++) {
          var mh2 = 0;
          for (c2 = 0; c2 < dk; c2++) {
            var cl2 = cells[r2 * dk + c2]; if (!cl2) continue;
            cl2.f.s = cl2.hs; mh2 = Math.max(mh2, cl2.h);
            textaUtV(cl2.id, cl2.R, cl2.Lr, cl2.f, G.x + c2 * (cw + bx), cw, G.jofnun || "vinstri", yg);
          }
          yg += mh2 + by;
        }
      }
    }

    /* c) the stack: rows top to bottom, shrunk together when too tall */
    var st = L.stafli;
    if (st) {
      var rows = [];
      (st.rod || []).forEach(function (id) {
        if (id === "strik") {
          var sk2 = st.strik || {};
          if (rows.length) rows.push({ k: id, strik: true, lw: sk2.w || 10, lh: sk2.strik || 0.25, sk: sk2 });
          return;
        }
        if (id === "logo") {
          if (!logo || logoSett) return;
          var lb = { w: (st.logo && st.logo.w) || st.w, h: (st.logo && st.logo.h) || 8 };
          var fl = fitLogo(lb, logo === "stadgengill" ? 2.2 : logo.r);
          rows.push({ k: id, logo: true, lw: fl.w, lh: fl.h, min: (st.logo && st.logo.min_h) || fl.h * 0.6, svaedi: lb });
          logoSett = true;
          return;
        }
        var R = RAD[id]; if (!R) return;
        merkjaSynd(R);
        var u = einingar(R, D, LET); if (!u.length) return;
        var Lr = LET[R.letur], f = fittaRik(u, st.w, Lr, R);
        rows.push({ k: id, R: R, Lr: Lr, f: f, s0: f.s });
      });
      /* a strik row needs a row on both sides */
      while (rows.length && rows[rows.length - 1].strik) rows.pop();
      var bil = st.bil || {};
      /* gap after a row: bil["a>b"] for that pair first, then bil[a] */
      var gap = function (i) {
        var kk = rows[i - 1].k, par = kk + ">" + rows[i].k;
        return bil[par] != null ? bil[par] : bil[kk] != null ? bil[kk] : (st.bil_sjalfgefid != null ? st.bil_sjalfgefid : 1.5);
      };
      var haedVid = function (fk2) {
        var t = 0, i;
        for (i = 0; i < rows.length; i++) {
          var r = rows[i];
          if (r.strik) { r.h = r.lh; }
          else if (r.f) { r.hs = Math.max(r.Lr.min_mm || 1, r.s0 * fk2); if (r.s0 < (r.Lr.min_mm || 1)) r.hs = r.s0; r.h = haedRadar(r.Lr, r.hs, r.f.linur.length); }
          else { r.h = Math.max(r.min, r.lh * fk2); r.hs = r.h / r.lh; }
          t += r.h + (i ? gap(i) : 0);
        }
        return t;
      };
      var fk3 = 1, heild = haedVid(1);
      if (heild > st.h + 1e-6) {
        var lo3 = 0, hi3 = 1, j3;
        for (j3 = 0; j3 < 24; j3++) { var mid3 = (lo3 + hi3) / 2; if (haedVid(mid3) > st.h) hi3 = mid3; else lo3 = mid3; }
        fk3 = lo3; heild = haedVid(fk3);
        if (heild > st.h + 0.05) vand.push(v("of_hatt"));
      }
      var lod2 = st.lodrett || "midja";
      var y = lod2 === "efst" ? st.y : lod2 === "nedst" ? st.y + st.h - heild : st.y + (st.h - heild) / 2;
      var jof2 = st.jofnun || "midja";
      rows.forEach(function (r, i) {
        if (i) y += gap(i);
        if (r.strik) {
          var sx0 = jafna(jof2, st.x, st.w, r.lw);
          U.linur.push({ x1: sx0, y1: y + r.lh / 2, x2: sx0 + r.lw, y2: y + r.lh / 2, strik: r.lh, endi: "butt" });
        } else if (r.f) {
          r.f.s = r.hs;
          textaUtV(r.k, r.R, r.Lr, r.f, st.x, st.w, jof2, y);
        } else {
          var w2 = r.lw * r.hs;
          setjaLogoV(jafna(jof2, st.x, st.w, w2), y, w2, r.h, r.svaedi);
        }
        y += r.h;
      });
    }
    if (logo && !logoSett && !U.logo) vand.push(vV("logo_passar_ekki", T, "logo"));

    /* Fields typed that this size or look does not show (1.3.1): they are
       listed in info.falin, get a note, and never reach the summary, the
       cart, the aria text or the production header (eiginleikar). */
    U.syndir = {}; U.info.synd = []; U.info.falin = [];
    for (rk in reitir) if (has(reitir, rk) && gildi(D, rk)) {
      if (synd[rk]) { U.syndir[rk] = 1; U.info.synd.push(rk); }
      else { U.info.falin.push(rk); vand.push(vV("sest_ekki", T, rk)); }
    }
    U.info.letur = lk;

    /* Safe area on the real ink (accents, descenders, italic overhang).
       1.3.1: an overshoot up to orugg_vik (0.1 mm) is fine as long as the
       ink stays clear of a frame's inner edge. */
    var ins = L.orugg != null ? L.orugg : 3, vik = L.orugg_vik != null ? L.orugg_vik : 0.1;
    var og = { x0: ins - vik, y0: ins - vik, x1: B - ins + vik, y1: H - ins + vik };
    [].concat(U.rammi || []).forEach(function (rm) {
      var g = rammiGeo(rm, B, H, U.horn), fx = g.innriX + 0.2, fy = g.innriY + 0.2;
      og = { x0: Math.max(og.x0, fx), y0: Math.max(og.y0, fy), x1: Math.min(og.x1, B - fx), y1: Math.min(og.y1, H - fy) };
    });
    U.textar.forEach(function (t0) {
      t0.linur.forEach(function (ln) {
        ln.hlutar.forEach(function (h) {
          var b = blek(h.L, h.t, h.s), x0 = ln.x + h.dx * ln.sx, x1 = x0 + Math.max(b.haegri, h.w) * ln.sx;
          if (ln.y - b.upp < og.y0 - 1e-6 || ln.y + b.nidur > og.y1 + 1e-6 || x0 + b.vinstri * ln.sx < og.x0 - 1e-6 || x1 > og.x1 + 1e-6) {
            if (!vand.some(function (q) { return q.kodi === "utan_oruggs"; })) vand.push(v("utan_oruggs"));
          }
        });
      });
    });
    return U;
  }

  /* ---- drawing ---- */
  /* Tone in tone metal engraving: the letters keep the metal photo under a
     darker matt tone (op), the upper wall of each cut in shade, a light lip
     below. Black marking on steel: flat, a hair soft at the edge. */
  function grofSiaV(id, E, B, H) {
    var f = '<filter id="' + id + 'g" filterUnits="userSpaceOnUse" x="-2" y="-2" width="' + (B + 4) + '" height="' + (H + 4) + '" color-interpolation-filters="sRGB">';
    if (E.graf === "grafid") {
      f += '<feColorMatrix in="SourceGraphic" type="matrix" values="1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 ' + E.op + ' 0" result="fy"/>' +
        '<feOffset in="SourceAlpha" dy="0.07" result="o1"/><feComposite in="o1" in2="SourceAlpha" operator="out" result="n1"/>' +
        '<feGaussianBlur in="n1" stdDeviation="0.03" result="n2"/><feFlood flood-color="#ffffff" flood-opacity="0.5"/><feComposite in2="n2" operator="in" result="lj"/>' +
        '<feOffset in="SourceAlpha" dy="0.09" result="o2"/><feComposite in="SourceAlpha" in2="o2" operator="out" result="e1"/>' +
        '<feGaussianBlur in="e1" stdDeviation="0.035" result="e2"/><feFlood flood-color="#000000" flood-opacity="0.5"/><feComposite in2="e2" operator="in" result="sk"/>' +
        '<feComposite in="sk" in2="SourceAlpha" operator="in" result="sk2"/>' +
        '<feMerge><feMergeNode in="lj"/><feMergeNode in="fy"/><feMergeNode in="sk2"/></feMerge>';
    } else if (E.graf === "merkt") {
      f += '<feGaussianBlur in="SourceGraphic" stdDeviation="0.02" result="mj"/>' +
        '<feColorMatrix in="mj" type="matrix" values="1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 ' + (E.op || 1) + ' 0"/>';
    } else return grofSia(id, E, B, H);
    return f + "</filter>";
  }
  function efniMynd(O, ek, sk) {
    var m = O.efni || SMBarm.efni || {}, E = EFNI[ek], nafn = (E && E.mynd) || ek;
    return m[ek + "@" + sk] || m[nafn + "@" + sk] || m[ek] || m[nafn] || null;
  }
  function textiRikSvg(t0, lit) {
    var s = "";
    t0.linur.forEach(function (ln) {
      var inn = "";
      ln.hlutar.forEach(function (h) {
        var L = h.L;
        inn += '<text x="' + r3(ln.sx < 0.999 ? h.dx : ln.x + h.dx) + '" y="' + (ln.sx < 0.999 ? 0 : r3(ln.y)) + '" font-family="' + esc("'" + (({"Dancing Script":"SM Skrift","IBM Plex Mono":"SM Mono"})[L.family] || L.family) + "', " + vara(L)) + '" font-size="' + r3(h.s) + '" font-weight="' + (L.weight || 400) + '"' +
          (L.style === "italic" ? ' font-style="italic"' : "") + (L.tracking_em ? ' letter-spacing="' + r3(L.tracking_em * h.s) + '"' : "") +
          ' fill="' + lit + '" text-rendering="geometricPrecision">' + esc(h.t) + "</text>";
      });
      s += ln.sx < 0.999 ? '<g transform="translate(' + r3(ln.x) + " " + r3(ln.y) + ") scale(" + r3(ln.sx) + ' 1)">' + inn + "</g>" : inn;
    });
    return s;
  }
  /* Spoken description: only the fields on the sign (1.3.1) */
  function lysingV(T, D, U) {
    U = U || uppsetningV(T, D, {});
    var hl = [], r = T.reitir || {}, k;
    for (k in r) if (has(r, k) && k !== "texti" && U.syndir[k]) hl.push(gildi(D, k));
    return (varaAf(T).aria || ORD.ariaV) + (hl.length ? ": " + hl.join(", ") : "");
  }
  /* The template's own dividers as score lines (LINA). The old engraved
     dividers stopped at the edges of the frame band and of each other; a
     score line runs on to the centre line of the line it meets, so every
     T joint closes. Layout stroke lines (stafli strik) are not included. */
  function linurLina(U) {
    var L = U.linur.slice(0, U.snidLinur || 0), B = U.B, H = U.H, lodr = [], larr = [], E = 0.01;
    [].concat(U.rammi || []).forEach(function (rm) {
      var g = rammiGeo(rm, B, H, U.horn), h = g.sw / 2;
      lodr.push({ c: g.x, h: h, a: g.y, b: g.y + g.h }, { c: g.x + g.w, h: h, a: g.y, b: g.y + g.h });
      larr.push({ c: g.y, h: h, a: g.x, b: g.x + g.w }, { c: g.y + g.h, h: h, a: g.x, b: g.x + g.w });
    });
    L.forEach(function (ln) {
      var h = (ln.strik || 0.25) / 2;
      if (Math.abs(ln.x1 - ln.x2) < 1e-6) lodr.push({ c: ln.x1, h: h, a: Math.min(ln.y1, ln.y2), b: Math.max(ln.y1, ln.y2) });
      else if (Math.abs(ln.y1 - ln.y2) < 1e-6) larr.push({ c: ln.y1, h: h, a: Math.min(ln.x1, ln.x2), b: Math.max(ln.x1, ln.x2) });
    });
    function smella(e, stada, hopur) {
      for (var i = 0; i < hopur.length; i++) {
        var q = hopur[i];
        if (stada < q.a - E || stada > q.b + E) continue;
        if (Math.abs(e - (q.c - q.h)) < E || Math.abs(e - (q.c + q.h)) < E) return q.c;
      }
      return e;
    }
    return L.map(function (ln) {
      var n = { x1: ln.x1, y1: ln.y1, x2: ln.x2, y2: ln.y2 };
      if (Math.abs(ln.y1 - ln.y2) < 1e-6) { n.x1 = smella(ln.x1, ln.y1, lodr); n.x2 = smella(ln.x2, ln.y1, lodr); }
      else if (Math.abs(ln.x1 - ln.x2) < 1e-6) { n.y1 = smella(ln.y1, ln.x1, larr); n.y2 = smella(ln.y2, ln.x1, larr); }
      return n;
    });
  }
  function teiknaV(T, D, O) {
    D = D || {}; O = O || {};
    var U = uppsetningV(T, D, O);
    var id = "smv" + (++NR) + "-";
    var E = EFNI[U.efni], lit = E.kjarni, B = U.B, H = U.H, R = U.horn;
    var p = O.spassia != null ? O.spassia : 3;
    var kt = O.kantur === false ? 0 : (O.kanturMm != null ? O.kanturMm : 0.6);
    var mynd = efniMynd(O, U.efni, U.staerd), skuggi = O.skuggi !== false;
    var s = [], def = [], graf = [];
    var vh = H + 2 * p + kt;
    /* 1.4.0: slot (a hole through the plate) and the steel wire loop above it */
    var PV = varaAf(T), gat = U.gat || null, lk = O.lykkja && PV.lykkja ? PV.lykkja : null, ofan = lk ? lk.ofan : 0;
    var vidd = O.pxmm ? ' width="' + r3((B + 2 * p) * O.pxmm) + '" height="' + r3((vh + ofan) * O.pxmm) + '"' : ' width="100%"';
    var aria = O.aria != null ? O.aria : lysingV(T, D, U);
    s.push('<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="' + (-p) + " " + (ofan ? r3(-p - ofan) : (-p)) + " " + (B + 2 * p) + " " + r3(vh + ofan) + '"' + vidd +
      (aria ? ' role="img" aria-label="' + esc(aria) + '"' : ' aria-hidden="true" focusable="false"') + ' data-smv-staerd="' + U.staerd + '" data-smv-efni="' + U.efni + '" data-smv-snid="' + esc(T.key || "") + '">');
    def.push('<clipPath id="' + id + 'c">' + rrect(0, 0, B, H, R) + "</clipPath>");
    def.push(grofSiaV(id, E, B, H));
    if (skuggi) {
      def.push('<filter id="' + id + 's" filterUnits="userSpaceOnUse" x="' + (-p) + '" y="' + (-p) + '" width="' + (B + 2 * p) + '" height="' + r3(vh) + '" color-interpolation-filters="sRGB">' +
        '<feGaussianBlur in="SourceAlpha" stdDeviation="0.9"/><feOffset dx="0.35" dy="0.9" result="a"/>' +
        '<feFlood flood-color="#000000" flood-opacity="0.22"/><feComposite in2="a" operator="in" result="sa"/>' +
        '<feGaussianBlur in="SourceAlpha" stdDeviation="0.2"/><feOffset dx="0.15" dy="0.25" result="b"/>' +
        '<feFlood flood-color="#000000" flood-opacity="0.32"/><feComposite in2="b" operator="in" result="sb"/>' +
        "<feMerge><feMergeNode in=\"sa\"/><feMergeNode in=\"sb\"/></feMerge></filter>");
    }
    def.push('<linearGradient id="' + id + 'b" x1="0" y1="0" x2="0" y2="1">' +
      '<stop offset="0" stop-color="#ffffff" stop-opacity="' + (E.glampi || 0) + '"/>' +
      '<stop offset="0.12" stop-color="#ffffff" stop-opacity="0"/></linearGradient>');
    var bn = E.botn || { h: 0.4, lit: "#000000", op: 0 };
    def.push('<linearGradient id="' + id + 'n" gradientUnits="userSpaceOnUse" x1="0" y1="' + r3(H - bn.h) + '" x2="0" y2="' + H + '">' +
      '<stop offset="0" stop-color="' + bn.lit + '" stop-opacity="0"/>' +
      '<stop offset="0.75" stop-color="' + bn.lit + '" stop-opacity="' + r3(bn.op * 0.7) + '"/>' +
      '<stop offset="1" stop-color="' + bn.lit + '" stop-opacity="' + bn.op + '"/></linearGradient>');
    if (E.korn && O.korn !== false) def.push('<filter id="' + id + 'k" filterUnits="userSpaceOnUse" x="0" y="0" width="' + B + '" height="' + H + '" color-interpolation-filters="sRGB">' +
      '<feTurbulence type="fractalNoise" baseFrequency="0.006 4.2" numOctaves="2" seed="' + (E.mynd === "messing" ? 7 : 3) + '"/>' +
      '<feColorMatrix type="matrix" values="1.3 0 0 0 -0.15 1.3 0 0 0 -0.15 1.3 0 0 0 -0.15 0 0 0 0 1"/></filter>');
    if (kt) def.push('<linearGradient id="' + id + 'e" x1="0" y1="0" x2="1" y2="0"><stop offset="0" stop-color="#000" stop-opacity="0.25"/><stop offset="0.5" stop-color="#000" stop-opacity="0"/><stop offset="1" stop-color="#000" stop-opacity="0.3"/></linearGradient>');

    U.flatar.forEach(function (fl) { graf.push(rrect(fl.x, fl.y, fl.w, fl.h, fl.horn || 0, ' fill="' + lit + '"')); });
    if (U.grafik) U.grafik.forEach(function (g) { graf.push(g.lina ? '<path d="' + esc(g.d) + '" fill="none" stroke="' + lit + '" stroke-width="' + r3(RAMMI_FORSKODUN_MM) + '"/>' : '<path d="' + esc(g.d) + '" fill="' + lit + '"/>'); });
    if (U.rammi) [].concat(U.rammi).forEach(function (rm) {
      var g = rammiGeo(rm, B, H, R);
      graf.push(rrect(g.x, g.y, g.w, g.h, g.r, ' fill="none" stroke="' + lit + '" stroke-width="' + r3(g.lina ? g.sw : RAMMI_FORSKODUN_MM) + '"'));
    });
    var snidL = linurLina(U);
    U.linur.forEach(function (ln, i) {
      var sl = i < snidL.length ? snidL[i] : null, q = sl || ln;
      graf.push('<line x1="' + r3(q.x1) + '" y1="' + r3(q.y1) + '" x2="' + r3(q.x2) + '" y2="' + r3(q.y2) + '" stroke="' + lit + '" stroke-width="' + r3(sl ? RAMMI_FORSKODUN_MM : (ln.strik || 0.25)) + '" stroke-linecap="' + (ln.endi || "butt") + '"/>');
    });
    if (U.logo) {
      var g = U.logo;
      if (g.stadgengill) graf.push(stadgengillSvg(g, lit));
      else {
        var img = '<image href="' + esc(g.mynd) + '" xlink:href="' + esc(g.mynd) + '" x="' + r3(g.x) + '" y="' + r3(g.y) + '" width="' + r3(g.w) + '" height="' + r3(g.h) + '" preserveAspectRatio="none"';
        def.push('<mask id="' + id + 'l" maskUnits="userSpaceOnUse" x="0" y="0" width="' + B + '" height="' + H + '">' + img + "/></mask>");
        graf.push('<rect x="' + r3(g.x) + '" y="' + r3(g.y) + '" width="' + r3(g.w) + '" height="' + r3(g.h) + '" fill="' + lit + '" mask="url(#' + id + 'l)"/>');
      }
    }
    U.textar.forEach(function (t0) { graf.push(textiRikSvg(t0, lit)); });

    if (gat) {
      def.push('<mask id="' + id + 'h" maskUnits="userSpaceOnUse" x="' + (-p) + '" y="' + r3(-p - ofan) + '" width="' + (B + 2 * p) + '" height="' + r3(vh + ofan) + '">' +
        '<rect x="' + (-p) + '" y="' + r3(-p - ofan) + '" width="' + (B + 2 * p) + '" height="' + r3(vh + ofan) + '" fill="#ffffff"/>' + rrect(gat.x, gat.y, gat.w, gat.h, gat.r, ' fill="#000000"') + "</mask>");
      def.push('<clipPath id="' + id + 'r">' + rrect(gat.x, gat.y, gat.w, gat.h, gat.r) + "</clipPath>");
    }
    if (lk) def.push(lykkjaDefs(id));
    s.push("<defs>" + def.join("") + "</defs>");
    if (lk) s.push(lykkjaSvg(lk, "aftur", id));
    if (gat) s.push('<g mask="url(#' + id + 'h)">');
    if (skuggi) s.push('<g filter="url(#' + id + 's)">' + rrect(0, 0, B, H + kt, R, ' fill="' + E.flotur + '"') + "</g>");
    if (kt) {
      s.push(rrect(0, kt, B, H, R, ' fill="' + E.kantur + '"'));
      s.push(rrect(0, kt, B, H, R, ' fill="url(#' + id + 'e)"'));
    }
    s.push('<g clip-path="url(#' + id + 'c)">');
    s.push(rrect(0, 0, B, H, 0, ' fill="' + E.flotur + '"'));
    if (mynd) s.push('<image href="' + esc(mynd) + '" xlink:href="' + esc(mynd) + '" x="0" y="0" width="' + B + '" height="' + H + '" preserveAspectRatio="none"/>');
    /* Metal: the atlas photos hold about 3 px per mm, so a fine brushed grain
       (horizontal hairlines, soft light) keeps the face crisp when enlarged. */
    if (E.korn && O.korn !== false) s.push('<rect x="0" y="0" width="' + B + '" height="' + H + '" filter="url(#' + id + 'k)" opacity="' + E.korn + '" style="mix-blend-mode:soft-light"/>');
    s.push('<g filter="url(#' + id + 'g)">' + graf.join("") + "</g>");
    if (bn.op) s.push('<rect x="0" y="' + r3(H - bn.h) + '" width="' + B + '" height="' + r3(bn.h) + '" fill="url(#' + id + 'n)"/>');
    if (E.glampi) s.push(rrect(0, 0, B, H, R, ' fill="none" stroke="url(#' + id + 'b)" stroke-width="0.4"'));
    s.push("</g>");
    var li = E.lina || { lit: "#000000", op: 0.3 };
    s.push(rrect(0.03, 0.03, B - 0.06, H - 0.06, Math.max(0, R - 0.03), ' fill="none" stroke="' + li.lit + '" stroke-opacity="' + li.op + '" stroke-width="0.07"'));
    if (gat) {
      s.push("</g>");
      /* the cut wall inside the slot (the plate's edge colour) and its rim */
      s.push('<g clip-path="url(#' + id + 'r)"><rect x="' + r3(gat.x) + '" y="' + r3(gat.y) + '" width="' + r3(gat.w) + '" height="' + r3(Math.max(kt, 0.4) * 1.3) + '" fill="' + E.kantur + '"/></g>');
      s.push(rrect(gat.x, gat.y, gat.w, gat.h, gat.r, ' fill="none" stroke="' + li.lit + '" stroke-opacity="' + li.op + '" stroke-width="0.07"'));
    }
    if (lk) s.push(lykkjaSvg(lk, "fram", id));
    s.push("</svg>");
    return s.join("");
  }
  /* 1.4.0: the steel wire loop (preview only). An oval through the slot: the
     left half runs behind the plate (seen above it and through the slot), the
     right half over the bridge above the slot. The screw lock sits on the back
     half. Brushed steel: a dark body, a light line along it, a soft shadow on
     the plate under the front half. */
  function lykkjaDefs(id) {
    return '<linearGradient id="' + id + 'lg" x1="0" y1="0" x2="1" y2="0">' +
      '<stop offset="0" stop-color="#6b7177"/><stop offset="0.45" stop-color="#e8ecef"/><stop offset="0.6" stop-color="#c3c8cc"/><stop offset="1" stop-color="#5d6369"/></linearGradient>';
  }
  function lykkjaSvg(lk, hluti, id) {
    var cx = lk.cx, cy = lk.cy, rx = lk.rx, ry = lk.ry, d = lk.d, t = cx + " " + r3(cy - ry), b = cx + " " + r3(cy + ry), s = "";
    var bogi = hluti === "fram" ? "M" + t + "A" + rx + " " + ry + " 0 0 1 " + b : "M" + b + "A" + rx + " " + ry + " 0 0 1 " + t;
    if (hluti === "fram") s += '<path d="' + bogi + '" transform="translate(0.35 0.7)" fill="none" stroke="#000000" stroke-opacity="0.22" stroke-width="' + r3(d * 1.1) + '" stroke-linecap="round"/>';
    s += '<path d="' + bogi + '" fill="none" stroke="#6f757b" stroke-width="' + d + '" stroke-linecap="round"/>';
    s += '<path d="' + bogi + '" transform="translate(-0.18 -0.12)" fill="none" stroke="#dfe3e6" stroke-width="' + r3(d * 0.32) + '" stroke-linecap="round"/>';
    if (hluti === "aftur" && lk.las) {
      var a = lk.las.a * Math.PI / 180, x = cx + rx * Math.cos(a), y = cy + ry * Math.sin(a);
      var ang = Math.atan2(ry * Math.cos(a), -rx * Math.sin(a)) * 180 / Math.PI - 90, L = lk.las.l, W = lk.las.d;
      s += '<g transform="translate(' + r3(x) + " " + r3(y) + ") rotate(" + r3(ang) + ')">' +
        '<rect x="' + r3(-W / 2) + '" y="' + r3(-L / 2) + '" width="' + W + '" height="' + L + '" rx="' + r3(W * 0.42) + '" fill="url(#' + id + 'lg)" stroke="#50565b" stroke-width="0.12"/>' +
        '<line x1="' + r3(-W / 2) + '" y1="-0.2" x2="' + r3(W / 2) + '" y2="-0.2" stroke="#50565b" stroke-width="0.14"/>' +
        '<line x1="' + r3(-W / 2) + '" y1="0.25" x2="' + r3(W / 2) + '" y2="0.25" stroke="#ffffff" stroke-opacity="0.5" stroke-width="0.1"/></g>';
    }
    return s;
  }

  /* ---- order data ---- */
  /* Record for the hidden cart property _framleidsla (same shape family as
     the badges): template, material, size, the fields as typed, and the fit
     the customer saw, per row. */
  function framleidslaV(T, D, O) {
    D = D || {}; O = O || {};
    var U = uppsetningV(T, D, O), d = {}, r = T.reitir || {}, k, f = {};
    for (k in r) if (has(r, k) && U.syndir[k]) d[k] = gildi(D, k);
    U.textar.forEach(function (t0) {
      var x = { mm: r3(t0.s), cap: r3(maelingar(t0.L).cap * t0.s), l: t0.linur.length };
      if (t0.sx < 0.999) x.sx = r3(t0.sx);
      if (t0.linur.length > 1) x.t = t0.linur.map(function (ln) { return ln.hlutar.map(function (h) { return h.t; }).join(""); });
      f[t0.rod] = x;
    });
    if (U.logo) f.logo = { x: r3(U.logo.x), y: r3(U.logo.y), w: r3(U.logo.w), h: r3(U.logo.h) };
    return {
      v: "SMV1", vel: VERSION, s: (T.vara || "verkamerki") + "." + (T.key || "") + "@" + (T.v || 1),
      e: U.gat ? { efni: U.efni, staerd: U.staerd, b: U.B, h: U.H, horn: U.horn, gat: U.gat, letur: U.letur || null } : { efni: U.efni, staerd: U.staerd, b: U.B, h: U.H, horn: U.horn, letur: U.letur || null },
      d: d, logo: U.logo ? (O.logo || "skra") : null, f: f,
      vandamal: U.vand.map(function (q) { return q.kodi + (q.reitur ? ":" + q.reitur : ""); })
    };
  }
  /* Visible cart properties, fixed Icelandic keys: the look, the font and
     then the fields in field order (keys from the template, eig). 1.3.1:
     only the fields that are on the sign; a field the look or size does
     not show is left out (stada().falin lists those for the page). */
  function eiginleikar(T, D, O) {
    D = D || {};
    var U = uppsetningV(T, D, O || {}), ut = {}, r = T.reitir || {}, k;
    ut[ORD.eigV.utlit] = (T.nr ? T.nr + " \u00b7 " : "") + tx(T.heiti);
    if (U.letur) ut[ORD.eigV.letur] = tx(T.letur_val[U.letur].heiti);
    for (k in r) if (has(r, k) && U.syndir[k]) ut[r[k].eig || k] = gildi(D, k);
    return ut;
  }
  /* SMFram font id for a font: family without spaces, -italic, -weight */
  function smfLetur(L) { return String(L.family).toLowerCase().replace(/[^a-z0-9]/g, "") + (L.style === "italic" ? "-italic" : "") + "-" + (L.weight || 400); }
  function dRett(x, y, w, h, r, rangsaelis) {
    r = Math.max(0, Math.min(r || 0, w / 2, h / 2));
    var d;
    if (!rangsaelis) {
      d = "M" + r3(x + r) + " " + r3(y) + "H" + r3(x + w - r) + (r ? "A" + r3(r) + " " + r3(r) + " 0 0 1 " + r3(x + w) + " " + r3(y + r) : "") + "V" + r3(y + h - r) +
        (r ? "A" + r3(r) + " " + r3(r) + " 0 0 1 " + r3(x + w - r) + " " + r3(y + h) : "") + "H" + r3(x + r) + (r ? "A" + r3(r) + " " + r3(r) + " 0 0 1 " + r3(x) + " " + r3(y + h - r) : "") +
        "V" + r3(y + r) + (r ? "A" + r3(r) + " " + r3(r) + " 0 0 1 " + r3(x + r) + " " + r3(y) : "") + "Z";
    } else {
      d = "M" + r3(x + r) + " " + r3(y) + (r ? "A" + r3(r) + " " + r3(r) + " 0 0 0 " + r3(x) + " " + r3(y + r) : "") + "V" + r3(y + h - r) +
        (r ? "A" + r3(r) + " " + r3(r) + " 0 0 0 " + r3(x + r) + " " + r3(y + h) : "") + "H" + r3(x + w - r) + (r ? "A" + r3(r) + " " + r3(r) + " 0 0 0 " + r3(x + w) + " " + r3(y + h - r) : "") +
        "V" + r3(y + r) + (r ? "A" + r3(r) + " " + r3(r) + " 0 0 0 " + r3(x + w - r) + " " + r3(y) : "") + "Z";
    }
    return d;
  }
  /* Spec for the production core SMFram (sm-framleidsla.js): every text
     piece as outlined text at the position the customer saw, frames and
     rules, the logo mask, and the plate outline, square on every material.
     Acrylic is cut (SKERA-YTRA); steel and brass come cut to size (owner
     2026-09-27), so their outline is placement only (UTLINA).
     O.logoMynd: the logo mask (canvas or data URL) for GRAFA-MYND.
     1.3.1: a logo the preview cannot draw (PDF, AI, EPS), a described logo
     or one to come later gets a dashed placement box in GRAFA-MYND at the
     exact position and size the customer saw; the header names the file
     (O.logoNafn) or quotes the description (O.logo 'lysing', O.logoLysing).
     Only the fields on the sign go into the header. */
  /* Dashed placement box as a PNG (20 px per mm, 0.3 mm line) */
  function reiturMynd(w, h) {
    try {
      var k = 20, c = doc.createElement("canvas"), cw = Math.max(4, Math.round(w * k)), ch = Math.max(4, Math.round(h * k)), lw = 0.3 * k;
      c.width = cw; c.height = ch;
      var x = c.getContext("2d");
      x.strokeStyle = "#000000"; x.lineWidth = lw;
      if (x.setLineDash) x.setLineDash([1.2 * k, 0.8 * k]);
      x.strokeRect(lw / 2, lw / 2, cw - lw, ch - lw);
      return c.toDataURL("image/png");
    } catch (e) { return null; }
  }
  function mmT(n) { return String(r3(n)).replace(".", ","); }
  function smfram(T, D, O) {
    D = D || {}; O = O || {};
    var U = uppsetningV(T, D, O), E = EFNI[U.efni], B = U.B, H = U.H, hl = [];
    U.textar.forEach(function (t0) {
      t0.linur.forEach(function (ln) {
        ln.hlutar.forEach(function (h) {
          var x = ln.x + h.dx * ln.sx, el = { gerd: "texti", lag: "GRAFA", texti: h.t, letur: smfLetur(h.L), mm: r3(h.s), x: r3(x), y: r3(ln.y), jofnun: "vinstri" };
          if (h.L.tracking_em) el.stafabil = h.L.tracking_em;
          if (ln.sx < 0.999) { el.kreista = r3(ln.sx); el.kreistaUm = r3(x); }
          hl.push(el);
        });
      });
    });
    if (U.rammi) [].concat(U.rammi).forEach(function (rm) {
      var g = rammiGeo(rm, B, H, U.horn);
      /* every frame is a scored line (LINA) on its centre line, like the door sign frame ('grafa' too, 2026-09-29) */
      hl.push({ gerd: "rett", lag: "LINA", x: r3(g.x), y: r3(g.y), w: r3(g.w), h: r3(g.h), r: r3(g.r) });
    });
    var snidL = linurLina(U);
    snidL.forEach(function (ln) { hl.push({ gerd: "slod", lag: "LINA", d: "M" + r3(ln.x1) + " " + r3(ln.y1) + "L" + r3(ln.x2) + " " + r3(ln.y2) }); });
    U.linur.forEach(function (ln, i) {
      if (i < snidL.length) return;
      var sw = ln.strik || 0.25, x0 = Math.min(ln.x1, ln.x2), x1 = Math.max(ln.x1, ln.x2), y0 = Math.min(ln.y1, ln.y2), y1 = Math.max(ln.y1, ln.y2);
      if (Math.abs(ln.y1 - ln.y2) < 1e-6) hl.push({ gerd: "rett", lag: "GRAFA", x: r3(x0), y: r3(y0 - sw / 2), w: r3(x1 - x0), h: r3(sw) });
      else hl.push({ gerd: "rett", lag: "GRAFA", x: r3(x0 - sw / 2), y: r3(y0), w: r3(sw), h: r3(y1 - y0) });
    });
    if (U.logo && !U.logo.stadgengill) hl.push({ gerd: "mynd", lag: "GRAFA-MYND", src: O.logoMynd || U.logo.mynd, x: r3(U.logo.x), y: r3(U.logo.y), w: r3(U.logo.w), h: r3(U.logo.h), nafn: "logo", maski: true });
    else if (U.logo) {
      var rmy = reiturMynd(U.logo.w, U.logo.h);
      if (rmy) hl.push({ gerd: "mynd", lag: "GRAFA-MYND", src: rmy, x: r3(U.logo.x), y: r3(U.logo.y), w: r3(U.logo.w), h: r3(U.logo.h), nafn: "logo-reitur" });
    }
    if (U.grafik) U.grafik.forEach(function (g) { hl.push({ gerd: "slod", lag: g.lina ? "LINA" : "GRAFA", d: g.d }); });
    hl.push({ gerd: "rett", lag: E.fj === "malmur" || O.utlina ? "UTLINA" : "SKERA-YTRA", x: 0, y: 0, w: B, h: H, r: U.horn });
    /* 1.4.0: the slot is cut (SKERA-INNRA); on the back of a two sided tag
       the outline and slot are placement only (O.utlina) */
    if (U.gat) hl.push({ gerd: "rett", lag: O.utlina ? "UTLINA" : "SKERA-INNRA", x: U.gat.x, y: U.gat.y, w: U.gat.w, h: U.gat.h, r: U.gat.r });
    if (O.hopur || O.dx || O.dy) hl.forEach(function (el) {
      var dx = O.dx || 0, dy = O.dy || 0;
      if (O.hopur) el.hopur = O.hopur;
      if (!dx && !dy) return;
      if (el.gerd === "slod") el.fylki = [1, 0, 0, 1, dx, dy];
      else if (el.gerd === "hringur" || el.gerd === "sporaskja") { el.cx = r3(el.cx + dx); el.cy = r3(el.cy + dy); }
      else { el.x = r3(el.x + dx); el.y = r3(el.y + dy); if (el.kreistaUm != null) el.kreistaUm = r3(el.kreistaUm + dx); }
    });
    var F = ORD.framV, e = eiginleikar(T, D, O), lys = [], fast = {}, k;
    fast[ORD.eigV.utlit] = 1; fast[ORD.eigV.letur] = 1;
    for (k in fast) if (has(fast, k) && has(e, k)) lys.push([k, e[k]]);
    var PP = F.plataVara && F.plataVara[T.vara] ? F.plataVara[T.vara] : null;
    lys.push([F.efni, ORD.efni[U.efni]], [F.staerd, ORD.staerdirV[U.staerd] || U.staerd], [F.plata, PP ? (PP[E.fj] || PP.tvilitt) : E.fj === "malmur" ? F.malmur : F.akryl]);
    for (k in e) if (has(e, k) && !fast[k]) lys.push([k, e[k]]);
    if (U.logo) {
      var nf = O.logoNafn ? String(O.logoNafn) : "", lt = O.logoLysing ? umbreyta(null, O.logoLysing) : "";
      if (!U.logo.stadgengill) lys.push([F.logo, F.logoMynd + (nf ? " (" + nf + ")" : "")]);
      else if (nf) lys.push([F.logo, nf + ". " + F.logoSkra]);
      else if (lt) lys.push([F.logo, stofn(F.logoLysing, { t: lt })]);
      else lys.push([F.logo, F.logoSidar]);
      var sv = U.logo.svaedi || U.logo;
      lys.push([F.reitur, stofn(F.reiturTexti, { x: mmT(U.logo.x), y: mmT(U.logo.y), w: mmT(U.logo.w), h: mmT(U.logo.h), mw: mmT(sv.w), mh: mmT(sv.h) })]);
    }
    var ord = gildi(D, "nafn").split(" ").slice(0, 2).join(" ");
    return { vara: T.vara || "verkamerki", efni: U.efni, staerd: U.staerd, snid: (T.vara || "verkamerki") + "." + (T.key || "") + "@" + (T.v || 1), ord: ord, w: B, h: H, lysing: lys, hlutir: hl };
  }

  /* ------------------------------------------------------------------
     9. PUBLIC API
     ------------------------------------------------------------------ */
  var SMBarm = {
    version: VERSION,
    STAERDIR: STAERDIR, STAERD_SJALFGEFIN: STAERD_SJALFGEFIN, HORN: HORN, LITIR: LITIR, TAKN: TAKN, TAKN_HEITI: TAKN_HEITI, TAKN_SAMHEITI: TAKN_SAMHEITI,
    ord: ORD, VANDAMAL: ORD.vandamal, TAKN_ENGIN: ORD.taknEngin,
    staerdLykill: staerdLykill, litLykill: litLykill, framleidsla: framleidsla,
    efni: null,
    teikna: teikna,
    stada: stada,
    uppsetning: uppsetning,
    grafaLogo: grafaLogo,
    bakgrunnsLitur: bakgrunnsLitur,
    leturSlod: leturSlod,
    hlada: hlada,
    breidd: breidd,
    maelingar: maelingar,
    /* 1.3.0: multi field templates (verkamerki) */
    VORUR: VORUR, EFNI: EFNI, EFNI_ROD: EFNI_ROD,
    staerdLykillV: staerdLykillV, efniLykill: efniLykill,
    eiginleikar: eiginleikar, lysing: lysingV, smfram: smfram, smfLetur: smfLetur, tx: tx,
    /* 1.3.1 */
    leturLykill: leturLykill, rammiGeo: rammiGeo
  };
  win.SMBarm = SMBarm;
})(window);
